var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _g, _defs, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ":root>svg{display:none}:root>svg:target{display:block}")), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "Artboard_123",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.24 11.46a1.489 1.489 0 00-1.08-.46H20V9a3 3 0 00-3-3h-3.17a1 1 0 01-.71-.29l-.83-.83A3 3 0 0010.17 4H5a3 3 0 00-3 3v10a3 3 0 003 3h12a3 3 0 002.64-1.57l2.84-5.21a1.57 1.57 0 00.18-.72 1.5 1.5 0 00-.42-1.04zM5 6h5.17a1 1 0 01.71.29l.83.83a3 3 0 002.12.88H17a1 1 0 011 1v2H8.58a3 3 0 00-2.64 1.57L4 16.13V7a1 1 0 011-1zm12 12H5.26l2.44-4.48a1 1 0 01.88-.52h11.74l-2.44 4.47A1 1 0 0117 18z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "Artboard_178",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.88 10H9v-.76A3.24 3.24 0 005.76 6H4V3a1 1 0 00-2 0v17a1 1 0 102 0v-1h15v1a1 1 0 002 0v-1h1v-5.88A3.12 3.12 0 0018.88 10zM4 8h1.76A1.23 1.23 0 017 9.24V10H4V8zm0 9v-5h14.88A1.12 1.12 0 0120 13.12V17H4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H9a1 1 0 000 2h9a1 1 0 000-2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "align_center",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6a1 1 0 011-1h16a1 1 0 110 2H4a1 1 0 01-1-1zm4 3a1 1 0 000 2h10a1 1 0 000-2H7zm13 4H4a1 1 0 000 2h16a1 1 0 000-2zm-3 4H7a1 1 0 000 2h10a1 1 0 000-2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "align_justify",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7a1 1 0 010-2h16a1 1 0 110 2H4zm0 4h16a1 1 0 000-2H4a1 1 0 000 2zm0 4h16a1 1 0 000-2H4a1 1 0 000 2zm0 4h16a1 1 0 000-2H4a1 1 0 000 2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "align_left",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6a1 1 0 011-1h16a1 1 0 110 2H4a1 1 0 01-1-1zm1 5h10a1 1 0 000-2H4a1 1 0 000 2zm16 2H4a1 1 0 000 2h16a1 1 0 000-2zm-6 4H4a1 1 0 000 2h10a1 1 0 000-2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "align_right",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6a1 1 0 011-1h16a1 1 0 110 2H4a1 1 0 01-1-1zm17 3H10a1 1 0 000 2h10a1 1 0 000-2zm0 4H4a1 1 0 000 2h16a1 1 0 000-2zm0 4H10a1 1 0 000 2h10a1 1 0 000-2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "angle_arrow_down",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.71 9.71l-8 8a1.002 1.002 0 01-1.42 0l-8-8a1.004 1.004 0 011.42-1.42l7.29 7.3 7.29-7.3a1.004 1.004 0 011.42 1.42z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "angle_arrow_left",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.71 19.29a1.002 1.002 0 01-.325 1.639 1 1 0 01-1.095-.219l-8-8a1 1 0 010-1.42l8-8a1.004 1.004 0 011.42 1.42L8.41 12l7.3 7.29z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "angle_arrow_right",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.71 11.29a1.002 1.002 0 010 1.42l-8 8a1 1 0 01-1.639-.325 1 1 0 01.219-1.095l7.3-7.29-7.3-7.29a1.004 1.004 0 011.42-1.42l8 8z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "angle_arrow_small_down",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.71 10.71l-4 4a1.002 1.002 0 01-1.42 0l-4-4a1.004 1.004 0 111.42-1.42l3.29 3.3 3.29-3.3a1.004 1.004 0 011.42 1.42z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "angle_arrow_small_down_new_design",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28033 6.28033C5.98744 6.57322 5.51256 6.57322 5.21967 6.28033L0.219671 1.28033C-0.0732229 0.987436 -0.0732229 0.512563 0.219671 0.219669C0.512563 -0.0732236 0.987438 -0.0732236 1.28033 0.219669L5.75 4.68934L10.2197 0.21967C10.5126 -0.0732232 10.9874 -0.0732231 11.2803 0.21967C11.5732 0.512563 11.5732 0.987437 11.2803 1.28033L6.28033 6.28033Z",
    fill: "#2B2D3E"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "angle_arrow_small_left",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.71 15.29a1.004 1.004 0 11-1.42 1.42l-4-4a1 1 0 010-1.42l4-4a1.003 1.003 0 111.42 1.42L11.41 12l3.3 3.29z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "angle_arrow_small_right",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.71 12.71l-4 4a1.004 1.004 0 11-1.42-1.42l3.3-3.29-3.3-3.29a1.004 1.004 0 011.42-1.42l4 4a1.002 1.002 0 010 1.42z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "angle_arrow_small_up",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.71 14.71a1.002 1.002 0 01-1.42 0L12 11.41l-3.29 3.3a1.004 1.004 0 01-1.42-1.42l4-4a1 1 0 011.42 0l4 4a1.002 1.002 0 010 1.42z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "angle_arrow_up",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.71 15.71a1.002 1.002 0 01-1.42 0L12 8.41l-7.29 7.3a1.004 1.004 0 01-1.42-1.42l8-8a1 1 0 011.42 0l8 8a1.002 1.002 0 010 1.42z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "arrow_bottom",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.293 19.707l-6-6a1.003 1.003 0 111.42-1.42l4.29 4.3V4.997a1 1 0 012 0v11.59l4.29-4.3a1.004 1.004 0 111.42 1.42l-6 6a1.002 1.002 0 01-1.42 0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "arrow_left",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12a1 1 0 01-1 1H7.41l4.3 4.29a1.004 1.004 0 11-1.42 1.42l-6-6a1 1 0 010-1.42l6-6a1.003 1.003 0 111.42 1.42L7.41 11H19a1 1 0 011 1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "arrow_left_bottom",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.051 16.948V8.462a1.004 1.004 0 112.008 0l-.007 6.075 8.196-8.196a1 1 0 111.414 1.414l-8.196 8.196 6.075-.007a1.004 1.004 0 010 2.008H7.054a1.002 1.002 0 01-1.004-1.004z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "arrow_left_top",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7.055 6.048h8.486a1.004 1.004 0 010 2.008L9.465 8.05l8.196 8.196a1 1 0 11-1.414 1.414L8.052 9.464l.007 6.074a1.004 1.004 0 01-2.008 0V7.052a1 1 0 011.004-1.004z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "arrow_right",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.71 12.71l-6 6a1.004 1.004 0 01-1.42-1.42l4.3-4.29H5a1 1 0 010-2h11.59l-4.3-4.29a1.004 1.004 0 111.42-1.42l6 6a1.002 1.002 0 010 1.42z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "arrow_right_bottom",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.95 17.952H8.466a1.005 1.005 0 010-2.008l6.074.007-8.195-8.196a1 1 0 111.414-1.414l8.196 8.195-.008-6.074a1.004 1.004 0 012.009 0v8.486a1.002 1.002 0 01-1.004 1.004z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "arrow_right_top",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.955 7.052v8.486a1.005 1.005 0 01-2.008 0l.007-6.074-8.196 8.195a1 1 0 01-1.414-1.414l8.195-8.196-6.074.007a1.004 1.004 0 010-2.008h8.486a1 1 0 011.004 1.004z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "arrow_top",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12.713 4.293l6 6a1.003 1.003 0 11-1.42 1.42l-4.29-4.3v11.59a1 1 0 11-2 0V7.413l-4.29 4.3a1.004 1.004 0 01-1.42-1.42l6-6a1 1 0 011.42 0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "arrows_left_and_right",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 8.6l-3 3a.85.85 0 11-1.2-1.2L16.8 9H6a1 1 0 010-2h10.8l-1.4-1.4a.85.85 0 111.2-1.2l3 3a.85.85 0 010 1.2zM18 15H7.2l1.4-1.4a.85.85 0 00-1.2-1.2l-3 3a.85.85 0 000 1.2l3 3a.85.85 0 101.2-1.2L7.2 17H18a1 1 0 100-2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "arrows_up_and_down",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 7.4a.85.85 0 01-1.2 1.2L9 7.2V18a1 1 0 11-2 0V7.2L5.6 8.6a.85.85 0 01-1.2-1.2l3-3a.85.85 0 011.2 0l3 3zm8 8a.85.85 0 00-1.2 0L17 16.8V6a1 1 0 00-2 0v10.8l-1.4-1.4a.85.85 0 10-1.2 1.2l3 3a.85.85 0 001.2 0l3-3a.85.85 0 000-1.2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "back",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13.5a4.49 4.49 0 01-4.5 4.5H14a1 1 0 110-2h2.5a2.5 2.5 0 000-5H6.2l2.4 2.4a.85.85 0 01-1.2 1.2l-4-4a.85.85 0 010-1.2l4-4a.85.85 0 011.2 1.2L6.2 9h10.3a4.49 4.49 0 014.5 4.5z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "bar_chart",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19a1 1 0 01-1 1H4a1 1 0 010-2h16a1 1 0 011 1zM6 16a1 1 0 001-1V8a1 1 0 00-2 0v7a1 1 0 001 1zm4 0a1 1 0 001-1V4a1 1 0 00-2 0v11a1 1 0 001 1zm8 0a1 1 0 001-1V7a1 1 0 00-2 0v8a1 1 0 001 1zm-4 0a1 1 0 001-1v-3a1 1 0 00-2 0v3a1 1 0 001 1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "bell",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 15.05c-.37-.7-.83-1.38-1.18-2.06A4.511 4.511 0 0118 11V9.21a6.35 6.35 0 00-1.52-4.13 5.87 5.87 0 00-3.48-2V3a1 1 0 10-2 0v.09A6 6 0 006 9v2a4.51 4.51 0 01-.57 2c-.35.68-.81 1.36-1.18 2.06a2 2 0 00.31 2.34A2 2 0 006 18h3a3 3 0 006 0h3a2 2 0 001.44-.61 2 2 0 00.31-2.34zM12 19a1 1 0 01-1-1h2a1 1 0 01-1 1zm-6-3c.3-.56.78-1.27 1.2-2.1A6.33 6.33 0 008 11V9a4 4 0 014-4h.4A3.84 3.84 0 0115 6.38a4.38 4.38 0 011 2.83V11a6.33 6.33 0 00.79 2.89c.42.83.9 1.54 1.2 2.1H6V16z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "bin",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17v-6a1 1 0 012 0v6a1 1 0 01-2 0zm-3 1a1 1 0 001-1v-6a1 1 0 00-2 0v6a1 1 0 001 1zM21 7a1 1 0 01-1 1h-1v10.94a3 3 0 01-3 3H8a3 3 0 01-3-3V8H4a1 1 0 010-2h4V5a3 3 0 013-3h2a3 3 0 013 3v1h4a1 1 0 011 1zM10 6h4V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v1zm7 2H7v10.94a1 1 0 001 1h8a1 1 0 001-1V8z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "bookmark",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M18 2H8a3 3 0 00-3 3v15.59A2 2 0 005.63 22a2 2 0 002.78 0l4.47-4.46.12-.05.12.05L17.59 22A2 2 0 0021 20.59V5a3 3 0 00-3-3zm1 18.59l-4.46-4.47a2.2 2.2 0 00-3.08 0L7 20.58V8h12v12.59zM19 6H7V5a1 1 0 011-1h10a1 1 0 011 1v1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "boxes_arrows_left_right",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6a1 1 0 011-1h4.16l-1.23-1.42a.85.85 0 111.28-1.11l2.58 3a.533.533 0 01.06.1.71.71 0 01.08.15c.005.05.005.1 0 .15a.65.65 0 010 .32c.005.05.005.1 0 .15a.71.71 0 01-.08.15.533.533 0 01-.06.1l-2.58 3a.85.85 0 11-1.28-1.11L18.16 7H14a1 1 0 01-1-1zm-2-1.5v3A2.5 2.5 0 018.5 10h-3A2.5 2.5 0 013 7.5v-3A2.5 2.5 0 015.5 2h3A2.5 2.5 0 0111 4.5zm-2 0a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-3zM10 16H5.84l1.23-1.42a.85.85 0 10-1.28-1.11l-2.58 3a.53.53 0 00-.06.1.71.71 0 00-.08.15.83.83 0 000 .15.65.65 0 000 .32.83.83 0 000 .15.71.71 0 00.08.15.53.53 0 00.06.1l2.58 3a.85.85 0 101.28-1.11L5.84 18H10a1 1 0 000-2zm11-.5v3a2.5 2.5 0 01-2.5 2.5h-3a2.5 2.5 0 01-2.5-2.5v-3a2.5 2.5 0 012.5-2.5h3a2.5 2.5 0 012.5 2.5zm-2 0a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5v3a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-3z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "bulb",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a8 8 0 00-8 8 6 6 0 00.41 2.22c.42.95.984 1.83 1.67 2.61.6.75 1.26 1.53 1.92 2.49V19a3 3 0 003 3h2a3 3 0 003-3v-1.68c.89-1.3 1.79-2.27 2.56-3.31a8.521 8.521 0 001-1.79A6 6 0 0020 10a8 8 0 00-8-8zm1 18h-2a1 1 0 01-1-1v-1h4v1a1 1 0 01-1 1zm4.73-8.52a8.669 8.669 0 01-1.36 2.1c-.55.67-1.21 1.46-1.89 2.42H13v-4.18A3 3 0 0015 9a1 1 0 10-2 0 1 1 0 11-2 0 1 1 0 10-2 0 3 3 0 002 2.82V16H9.51c-.93-1.33-1.83-2.32-2.45-3.17a6.21 6.21 0 01-.79-1.35A4 4 0 016 10a6 6 0 1112 0 4 4 0 01-.27 1.48z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "calculator",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M18 2H6a3 3 0 00-3 3v14a3 3 0 003 3h12a3 3 0 003-3V5a3 3 0 00-3-3zm1 17a1 1 0 01-1 1H6a1 1 0 01-1-1V5a1 1 0 011-1h12a1 1 0 011 1v14zm-9.07-6.89a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm4.76 0a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm-4.76 4.67a1.25 1.25 0 11-1.25-1.25 1.241 1.241 0 011.25 1.25zm4.76 0a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM17 7a1 1 0 01-1 1H8a1 1 0 010-2h8a1 1 0 011 1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "calendar",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 13a1.25 1.25 0 112.5 0 1.25 1.25 0 01-2.5 0zM7 18.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm5-4a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm0 4a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm5-4a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM22 7v12a3 3 0 01-3 3H5a3 3 0 01-3-3V7a3 3 0 013-3h1V3a1 1 0 012 0v1h8V3a1 1 0 012 0v1h1a3 3 0 013 3zM4 7v1h16V7a1 1 0 00-1-1H5a1 1 0 00-1 1zm16 3H4v9a1 1 0 001 1h14a1 1 0 001-1v-9z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "camera",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8a5 5 0 100 10 5 5 0 000-10zm0 8a3 3 0 110-5.999A3 3 0 0112 16zm9.14-9.9A2.93 2.93 0 0019 5.17h-1.14a1 1 0 01-.73-.32l-1.4-1.48a1 1 0 00-.73-.31H9a1 1 0 00-.73.31l-1.4 1.48a1 1 0 01-.73.32H5a2.93 2.93 0 00-2.14.93A3.14 3.14 0 002 8.28v10.55A3.14 3.14 0 002.86 21a2.89 2.89 0 002.14.94h14a2.89 2.89 0 002.14-.94 3.14 3.14 0 00.86-2.17V8.28a3.14 3.14 0 00-.86-2.18zM20 18.83c.005.3-.106.59-.31.81a.931.931 0 01-.69.3H5a.93.93 0 01-.69-.3 1.16 1.16 0 01-.31-.81V8.28c-.005-.3.106-.59.31-.81a.93.93 0 01.69-.3h1.14a3 3 0 002.18-.94l1.11-1.17h5.14l1.11 1.17.73-.69-.73.69a3 3 0 002.18.94H19a.93.93 0 01.69.3c.204.22.315.51.31.81v10.55z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "car2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 9l-2.15-3.54A3 3 0 0015.87 4H8.13a3 3 0 00-2.57 1.46L3.41 9A2.85 2.85 0 001 11.85v2.3a2.82 2.82 0 001 2.15v.7a3 3 0 006 0h8a3 3 0 006 0v-.7a2.82 2.82 0 001-2.15v-2.3A2.85 2.85 0 0020.59 9zM7.27 6.49A1 1 0 018.13 6h7.74a1 1 0 01.85.49L18.23 9H5.77l1.5-2.51zM5 18a1 1 0 01-1-1h2a1 1 0 01-1 1zm3-3H3.85a.85.85 0 01-.85-.85V14h2a1 1 0 000-2H3v-.15a.85.85 0 01.85-.85h16.3a.85.85 0 01.85.85V12h-2a1 1 0 000 2h2v.15a.85.85 0 01-.85.85H8zm11 3a1 1 0 01-1-1h2a1 1 0 01-1 1zm-3-5a1 1 0 01-1 1H9a1 1 0 010-2h6a1 1 0 011 1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "cart",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M10.46 19.59a1.6 1.6 0 11-3.2.02 1.6 1.6 0 013.2-.02zM17.05 18a1.6 1.6 0 100 3.2 1.6 1.6 0 000-3.2zm3.39-9.75l-1.62 6.49A3 3 0 0115.91 17H10a3 3 0 01-2.91-2.27L4.69 5H3.1a1 1 0 010-2h2.37a1 1 0 011 .76L7.25 7h12.19a.89.89 0 01.28 0 1 1 0 01.72 1.24v.01zM18.19 9H7.75l1.31 5.24A1 1 0 0010 15h5.88a1 1 0 001-.76L18.19 9z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "cart_cross_inside",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M11.17 19.5a1.6 1.6 0 11-3.198 0 1.6 1.6 0 013.198 0zm6.6-1.6a1.6 1.6 0 100 3.2 1.6 1.6 0 000-3.2zm2.66-11a1 1 0 00-1.21.73l-1.62 6.52a1 1 0 01-1 .75h-5.85a1 1 0 01-1-.75L7.16 3.66a1 1 0 00-1-.76H3.81a1 1 0 000 2h1.6l2.43 9.73a3 3 0 002.91 2.27h5.88a3 3 0 002.91-2.27l1.62-6.48a1 1 0 00-.73-1.22V6.9zM11 11.62a1 1 0 001.41 0l1.31-1.31L15 11.62a1 1 0 001.41-1.41L15.13 8.9l1.31-1.31a1 1 0 10-1.42-1.41l-1.3 1.3-1.3-1.29A1 1 0 0011 7.6l1.3 1.3-1.3 1.3a1.002 1.002 0 000 1.42z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "cart_plus_inside",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M10.46 19.59a1.6 1.6 0 11-3.2.02 1.6 1.6 0 013.2-.02zM17.05 18a1.6 1.6 0 100 3.2 1.6 1.6 0 000-3.2zm2.67-11a1 1 0 00-1.22.73l-1.62 6.48a1 1 0 01-1 .76H10a1 1 0 01-1-.76L6.44 3.76a1 1 0 00-1-.76H3.1a1 1 0 100 2h1.59l2.43 9.73A3 3 0 0010 17h5.88a3 3 0 002.91-2.27l1.62-6.49A1 1 0 0019.72 7zm-9 3H12v1.25a1 1 0 102 0V10h1.26a1 1 0 000-2H14V6.75a1 1 0 00-2 0V8h-1.24a1 1 0 100 2h-.04z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "case",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6h-2V5a3 3 0 00-3-3h-4a3 3 0 00-3 3v1H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V9a3 3 0 00-3-3zM9 5a1 1 0 011-1h4a1 1 0 011 1v1H9V5zm11 14a1 1 0 01-1 1H5a1 1 0 01-1-1V9a1 1 0 011-1h14a1 1 0 011 1v10zm-2-2a1 1 0 01-1 1H7a1 1 0 010-2h10a1 1 0 011 1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "checkmark_round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M15.64 9.36a.91.91 0 010 1.28l-4 4a.91.91 0 01-1.28 0l-2-2a.91.91 0 011.28-1.28L11 12.73l3.36-3.37a.91.91 0 011.28 0zM22 12a10 10 0 11-20 0 10 10 0 0120 0zm-2 0a8 8 0 10-16 0 8 8 0 0016 0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "cloud_checkmark_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M20.65 9.87a4.53 4.53 0 00-2.48-1.35 6.62 6.62 0 00-2-2.92 6.16 6.16 0 00-3.95-1.44A6.47 6.47 0 007.75 6a6.21 6.21 0 00-1.93 4.39 3.6 3.6 0 00-2.19 1.1 3.93 3.93 0 000 5.39A3.58 3.58 0 006.25 18h11.11a4.48 4.48 0 003.26-1.42 4.92 4.92 0 000-6.7l.03-.01zm-1.48 5.33a2.48 2.48 0 01-1.81.79H6.25a1.59 1.59 0 01-1.17-.52 1.92 1.92 0 010-2.63 1.59 1.59 0 011.17-.52c.156-.018.314-.018.47 0a1 1 0 00.89-.27 1 1 0 00.29-.89 1.23 1.23 0 010-.2v-.55a4.15 4.15 0 011.33-3 4.47 4.47 0 013.07-1.26 4.17 4.17 0 012.68 1 4.66 4.66 0 011.47 2.27 1 1 0 001 1 2.5 2.5 0 011.79.81 2.93 2.93 0 010 4l-.07-.03zm-4.53-4.84a.91.91 0 010 1.28l-2 2a.91.91 0 01-1.28 0l-1-1a.91.91 0 011.28-1.28l.36.37 1.36-1.37a.91.91 0 011.28 0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "cloud_copy",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M20.39 10.8a4.45 4.45 0 00-2.48-1.36 6.66 6.66 0 00-2-2.92 6.22 6.22 0 00-4-1.44A6.5 6.5 0 007.5 6.9a6.14 6.14 0 00-1.94 4.39 3.62 3.62 0 00-2.19 1.09 3.93 3.93 0 00-1.06 2.7 3.89 3.89 0 001.06 2.69A3.63 3.63 0 006 18.92h11.11a4.529 4.529 0 003.26-1.42 4.9 4.9 0 001.32-3.37 4.84 4.84 0 00-1.3-3.33zm-1.47 5.28a2.49 2.49 0 01-1.81.8H6a1.61 1.61 0 01-1.18-.52 2 2 0 010-2.64A1.61 1.61 0 016 13.24a2.76 2.76 0 01.46 0 1 1 0 001.18-1.16v-.75a4.18 4.18 0 011.32-3A4.51 4.51 0 0112 7.08a4.17 4.17 0 012.68 1 4.72 4.72 0 011.48 2.27 1 1 0 001 1 2.47 2.47 0 011.78.81 2.85 2.85 0 01.76 2 2.89 2.89 0 01-.78 1.96v-.04z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "cloud_cross",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M20.39 10.8a4.45 4.45 0 00-2.48-1.36 6.66 6.66 0 00-2-2.92 6.22 6.22 0 00-4-1.44A6.46 6.46 0 007.5 6.9a6.14 6.14 0 00-1.94 4.39 3.62 3.62 0 00-2.19 1.09 3.93 3.93 0 00-1.06 2.7 3.89 3.89 0 001.06 2.69A3.63 3.63 0 006 18.92h11.11a4.48 4.48 0 003.26-1.42 4.9 4.9 0 001.32-3.37 4.84 4.84 0 00-1.3-3.33zm-1.47 5.28a2.49 2.49 0 01-1.81.8H6a1.61 1.61 0 01-1.18-.52 2 2 0 010-2.64A1.61 1.61 0 016 13.24c.153-.013.307-.013.46 0a1 1 0 001.18-1.16v-.75a4.18 4.18 0 011.32-3A4.51 4.51 0 0112 7.08a4.17 4.17 0 012.68 1 4.72 4.72 0 011.48 2.27 1 1 0 001 1h.06a2.471 2.471 0 011.78.81 2.85 2.85 0 01.76 2 2.89 2.89 0 01-.84 1.96v-.04zm-4.8-4.24l-.71.71.71.7a1.002 1.002 0 01-.705 1.71 1 1 0 01-.705-.29L12 14l-.71.71a1 1 0 11-1.41-1.42l.71-.7-.71-.71a1 1 0 111.41-1.42l.71.71.71-.71a1 1 0 111.41 1.42v-.04z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "cloud_disconnected",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08 12.84a1.91 1.91 0 00-.52 1.31 1.87 1.87 0 00.93 1.64 1.008 1.008 0 01-1 1.75 3.92 3.92 0 01-.88-6.08 3.6 3.6 0 012.19-1.1A6.21 6.21 0 017.75 6a6.47 6.47 0 014.46-1.81 6.18 6.18 0 013.6 1.16l.46.37a1 1 0 01.1 1.41A1 1 0 0115 7.2a3.922 3.922 0 00-.36-.2 4.15 4.15 0 00-2.43-.79 4.47 4.47 0 00-3.07 1.21 4.15 4.15 0 00-1.33 3v.55a1.23 1.23 0 000 .2 1 1 0 01-.29.89 1.001 1.001 0 01-.89.27 2.075 2.075 0 00-.47 0 1.59 1.59 0 00-1.08.51zM20.8 10a4.9 4.9 0 00-.39-.4 1 1 0 00-1.41.1 1 1 0 00.07 1.42l.22.22a2.8 2.8 0 01.71 1.87 2.87 2.87 0 01-.78 2 2.48 2.48 0 01-1.81.79h-4.17a1 1 0 000 2h4.12a4.48 4.48 0 003.26-1.42A4.85 4.85 0 0022 13.21 4.8 4.8 0 0020.8 10zm-1.09-3.71a1 1 0 00-1.42 0L6.62 18A1 1 0 108 19.38L19.71 7.71a1 1 0 000-1.42z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "cloud_download",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M15.62 16.86a.85.85 0 01-.09 1.2l-3 2.58a.53.53 0 01-.1.06.71.71 0 01-.15.08h-.62a.71.71 0 01-.15-.08.533.533 0 01-.1-.06l-3-2.58a.85.85 0 111.11-1.28L11 18v-7a1 1 0 012 0v7l1.42-1.23a.851.851 0 011.2.09zm2.31-10.94a6.65 6.65 0 00-6.22-4.46 6.86 6.86 0 00-4.63 1.85 6.24 6.24 0 00-2 4.5 3.8 3.8 0 00-2.3 1.11 4 4 0 000 5.5 3.76 3.76 0 002.71 1.16H7.6a1 1 0 000-2H5.46A1.831 1.831 0 014.18 13a2 2 0 01-.54-1.36 1.92 1.92 0 01.54-1.35 1.75 1.75 0 011.28-.55 2.38 2.38 0 01.5 0 1 1 0 00.9-.27 1 1 0 00.27-.9v-.7a4.25 4.25 0 011.39-3.1 4.85 4.85 0 013.27-1.31 4.67 4.67 0 014.42 3.35 1 1 0 001 1h.05a2.82 2.82 0 012.72 2.87 2.88 2.88 0 01-.82 2 2.71 2.71 0 01-1.94.84h-.68a1 1 0 100 2h.68a4.73 4.73 0 003.38-1.44 4.9 4.9 0 001.38-3.44 4.82 4.82 0 00-4.05-4.72z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "cloud_server_copy",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M20.89 10.5a4.54 4.54 0 01-1.28 3.17A4.33 4.33 0 0116.48 15H16a1 1 0 010-2h.47a2.379 2.379 0 001.7-.72 2.58 2.58 0 00.71-1.78A2.46 2.46 0 0016.52 8a1 1 0 01-1-1 4.12 4.12 0 00-3.89-2.94A4.29 4.29 0 008.7 5.2a3.73 3.73 0 00-1.23 2.74 2.62 2.62 0 000 .28v.33a1 1 0 01-1.1 1.23 1.72 1.72 0 00-.43 0 1.47 1.47 0 00-1.09.47 1.63 1.63 0 00-.47 1.16 1.61 1.61 0 00.47 1.15 1.47 1.47 0 001.09.44H8a1 1 0 110 2H5.94a3.521 3.521 0 01-2.53-1.07 3.68 3.68 0 010-5.11 3.55 3.55 0 012.07-1 5.75 5.75 0 011.85-4.08 6.27 6.27 0 014.26-1.69 6.09 6.09 0 015.69 4 4.46 4.46 0 013.61 4.45zM18 19a3 3 0 01-3 3H9a3 3 0 010-6h2v-4a1 1 0 012 0v4h2a3 3 0 013 3zm-2 0a1 1 0 00-1-1H9a1 1 0 100 2h6a1 1 0 001-1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "cloud_upload",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M15.64 14.14a.85.85 0 01-1.2.08L13 13v7a1 1 0 11-2 0v-7l-1.39 1.22a.85.85 0 01-1.318-1.02.84.84 0 01.208-.26l3-2.58.09-.06.15-.08h.63l.15.08.09.06 3 2.58a.85.85 0 01.03 1.2zm2.29-6.22a6.65 6.65 0 00-6.22-4.46 6.86 6.86 0 00-4.63 1.85 6.24 6.24 0 00-2 4.5 3.8 3.8 0 00-2.3 1.11 4 4 0 000 5.5 3.76 3.76 0 002.71 1.16H7.6a1 1 0 000-2H5.46A1.831 1.831 0 014.18 15a2 2 0 01-.54-1.36 1.92 1.92 0 01.54-1.35 1.75 1.75 0 011.28-.55c.166-.018.334-.018.5 0a1 1 0 00.9-.27 1 1 0 00.27-.9v-.76a4.25 4.25 0 011.39-3.1 4.85 4.85 0 013.27-1.31 4.67 4.67 0 014.42 3.35 1 1 0 001 1h.05a2.82 2.82 0 012.72 2.87 2.88 2.88 0 01-.82 2 2.71 2.71 0 01-1.94.84h-.68a1 1 0 100 2h.68a4.73 4.73 0 003.38-1.44 4.9 4.9 0 001.38-3.44 4.82 4.82 0 00-4.05-4.66z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "collapse",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9V5a1 1 0 012 0v1.59l3.29-3.3a1.004 1.004 0 011.42 1.42L17.41 8H19a1 1 0 110 2h-4a1 1 0 01-.37-.08 1 1 0 01-.32-.21A1 1 0 0114 9zm3.41 7H19a1 1 0 000-2h-4a1 1 0 00-.921.615A1.003 1.003 0 0014 15v4a1 1 0 002 0v-1.59l3.29 3.3a1.004 1.004 0 101.42-1.42L17.41 16zm-7.49-1.38A1 1 0 009 14H5a1 1 0 000 2h1.59l-3.3 3.29a1.004 1.004 0 001.42 1.42L8 17.41V19a1 1 0 102 0v-4a1 1 0 00-.08-.38zM9 4a1 1 0 00-1 1v1.59l-3.29-3.3a1.004 1.004 0 10-1.42 1.42L6.59 8H5a1 1 0 000 2h4a1 1 0 00.37-.08 1 1 0 00.54-.54A1 1 0 0010 9V5a1 1 0 00-1-1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "collapse_small",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14v5a1 1 0 01-2 0v-2.59l-4.29 4.3a1.004 1.004 0 11-1.42-1.42L7.59 15H5a1 1 0 010-2h5a1 1 0 01.921.615A1 1 0 0111 14zm9.71-10.71a1 1 0 00-1.42 0L15 7.59V5a1 1 0 00-2 0v5a1 1 0 00.29.7c.092.09.2.161.32.21A1 1 0 0014 11h5a1 1 0 000-2h-2.59l4.3-4.29a1 1 0 000-1.42z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "copy",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.375 5.244c-1.237 0-2.24.842-2.24 1.88v8.75c0 1.04 1.003 1.882 2.24 1.882h6.25c1.237 0 2.24-.842 2.24-1.881V8.437c0-.592-.332-1.15-.896-1.505L13.886 5.62a2.533 2.533 0 00-1.344-.376H8.375zm-4.01 1.88c0-1.86 1.795-3.368 4.01-3.368h4.167c.867 0 1.712.237 2.406.674l2.083 1.312c1.01.637 1.605 1.635 1.605 2.695v7.438c0 1.86-1.796 3.369-4.011 3.369h-6.25c-2.215 0-4.01-1.509-4.01-3.37v-8.75z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M7.324 8.736c0-1.45 1.4-2.625 3.125-2.625h4.167c.676 0 1.334.184 1.875.525l2.083 1.313c.787.495 1.25 1.273 1.25 2.1v7.437c0 1.45-1.399 2.625-3.125 2.625h-6.25c-1.726 0-3.125-1.175-3.125-2.625v-8.75z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "credit_card",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M19 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-3-3zM5 6h14a1 1 0 011 1v1H4V7a1 1 0 011-1zm15 11a1 1 0 01-1 1H5a1 1 0 01-1-1v-7h16v7zM6 15a1 1 0 011-1h6a1 1 0 010 2H7a1 1 0 01-1-1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "credit_card_2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 10.256a3.75 3.75 0 013.75-3.75h14a3.75 3.75 0 013.75 3.75v8a3.75 3.75 0 01-3.75 3.75h-14A3.75 3.75 0 011 18.256v-8zm3.75-2.25a2.25 2.25 0 00-2.25 2.25v8a2.25 2.25 0 002.25 2.25h14a2.25 2.25 0 002.25-2.25v-8a2.25 2.25 0 00-2.25-2.25h-14z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 2.752a.25.25 0 00-.346-.231l-9.63 3.985H18V2.752zm-.92-1.617a1.75 1.75 0 012.42 1.617v4.404c0 .47-.38.85-.85.85H4.753c-.93 0-1.184-1.28-.325-1.636l12.653-5.235zM2 12.256a.75.75 0 01.75-.75h18a.75.75 0 010 1.5h-18a.75.75 0 01-.75-.75zm2 5a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6a.75.75 0 01-.75-.75z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "cross",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M17.71 16.29a1.004 1.004 0 11-1.42 1.42L12 13.41l-4.29 4.3a1.004 1.004 0 01-1.42-1.42l4.3-4.29-4.3-4.29a1.004 1.004 0 111.42-1.42l4.29 4.3 4.29-4.3a1.004 1.004 0 111.42 1.42L13.41 12l4.3 4.29z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "cursor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M21.09 17.91a3 3 0 00-.88-2.12l-4.3-4.29 1.8-1.79a.76.76 0 00.11-.16.64.64 0 00.1-.18v-.15A.75.75 0 0018 9a1.469 1.469 0 000-.19.87.87 0 00-.17-.36l-.08-.12a.76.76 0 00-.16-.11.64.64 0 00-.18-.1l-12-4a1 1 0 00-1.36 1.2l4 12a.64.64 0 00.1.18.76.76 0 00.11.16l.12.08.18.12.18.05L9 18c.07.01.14.01.21 0h.15a.64.64 0 00.18-.1.76.76 0 00.16-.11l1-1 .79-.8 4.29 4.3a3 3 0 004.25 0l.17-.18a3 3 0 00.89-2.2zm-2.3.71l-.17.17a1 1 0 01-.71.3 1 1 0 01-.7-.3l-4.88-4.88h-.07v-.08a1.002 1.002 0 00-1.42 0l-.5.5-.85.86-2.91-8.61 8.57 2.86-1.36 1.35a1.002 1.002 0 000 1.42l5 5a1 1 0 010 1.41z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "dashboard_4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3H6a3 3 0 00-3 3v2a3 3 0 003 3h2a3 3 0 003-3V6a3 3 0 00-3-3zm1 5a1 1 0 01-1 1H6a1 1 0 01-1-1V6a1 1 0 011-1h2a1 1 0 011 1v2zm-1 5H6a3 3 0 00-3 3v2a3 3 0 003 3h2a3 3 0 003-3v-2a3 3 0 00-3-3zm1 5a1 1 0 01-1 1H6a1 1 0 01-1-1v-2a1 1 0 011-1h2a1 1 0 011 1v2zm9-15h-2a3 3 0 00-3 3v2a3 3 0 003 3h2a3 3 0 003-3V6a3 3 0 00-3-3zm1 5a1 1 0 01-1 1h-2a1 1 0 01-1-1V6a1 1 0 011-1h2a1 1 0 011 1v2zm-1 5h-2a3 3 0 00-3 3v2a3 3 0 003 3h2a3 3 0 003-3v-2a3 3 0 00-3-3zm1 5a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2a1 1 0 011-1h2a1 1 0 011 1v2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "dashboard_lines",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3H6a3 3 0 00-3 3v2a3 3 0 003 3h2a3 3 0 003-3V6a3 3 0 00-3-3zm1 5a1 1 0 01-1 1H6a1 1 0 01-1-1V6a1 1 0 011-1h2a1 1 0 011 1v2zm-1 5H6a3 3 0 00-3 3v2a3 3 0 003 3h2a3 3 0 003-3v-2a3 3 0 00-3-3zm1 5a1 1 0 01-1 1H6a1 1 0 01-1-1v-2a1 1 0 011-1h2a1 1 0 011 1v2zm9-5h-2a3 3 0 00-3 3v2a3 3 0 003 3h2a3 3 0 003-3v-2a3 3 0 00-3-3zm1 5a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2a1 1 0 011-1h2a1 1 0 011 1v2zM13 5a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1zm8 4a1 1 0 01-1 1h-6a1 1 0 110-2h6a1 1 0 011 1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "database_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M18 2H6a3 3 0 00-3 3v14a3 3 0 003 3h12a3 3 0 003-3V5a3 3 0 00-3-3zm0 18H6a1 1 0 01-1-1v-3h2a1 1 0 000-2H5v-4h2a1 1 0 000-2H5V5a1 1 0 011-1h12a1 1 0 011 1v3h-7a1 1 0 100 2h7v4h-7a1 1 0 000 2h7v3a1 1 0 01-1 1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "dialog",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15a3 3 0 003-3V6a3 3 0 00-3-3H5a3 3 0 00-3 3v6a3 3 0 003 3h1v2a1 1 0 00.49.88 1 1 0 001 0L12.27 15H15zm-7 .22V14a1 1 0 00-.29-.72A1 1 0 007 13H5a1 1 0 01-1-1V6a1 1 0 011-1h10a1 1 0 011 1v6a1 1 0 01-1 1h-3a1 1 0 00-.51.14L8 15.22zM23 12v4a3 3 0 01-3 3h-1v2a1 1 0 01-1.6.8L13.67 19H12a1 1 0 010-2h2c.123.004.245.028.36.07l.1.06.14.07L17 19v-1a1 1 0 011-1h2a1 1 0 001-1v-4a1 1 0 00-1-1 1 1 0 010-2 3 3 0 013 3z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "diamond",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M22.93 10.36a.8.8 0 000-.15A.996.996 0 0023 10v-.15a1.34 1.34 0 000-.17v-.06a.908.908 0 00-.08-.13.599.599 0 00-.06-.11l-5-6a.699.699 0 00-.16-.13l-.15-.1-.17-.05A.78.78 0 0017 3H7a.78.78 0 00-.21 0l-.17.05a.78.78 0 00-.15.1.7.7 0 00-.16.13l-5 6a.6.6 0 00-.06.11.91.91 0 00-.08.13v.06a1 1 0 000 .17L1 10a1 1 0 000 .17.8.8 0 000 .15v.06c.026.049.057.096.09.14a.973.973 0 00.07.11L11 21.42a1 1 0 00.24.36 1 1 0 001.18.11l.1-.07.1-.07.07-.08 10-10.93a.973.973 0 00.07-.11.98.98 0 00.09-.14l.08-.13zM7.47 5H9l-.68 4H4.14l3.33-4zm9.06 0l3.33 4h-4.18L15 5h1.53zM10 11h4l-2 6.52L10 11zm3.61-2h-3.3L11 5.16A.91.91 0 0011 5h2a.93.93 0 000 .16L13.61 9zM8 11v.06a1.23 1.23 0 000 .2l1.74 5.78L4.26 11H8zm7.94.29a1.237 1.237 0 000-.2V11h3.76l-5.51 6.05 1.75-5.76z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "document_minus",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2.75c-.69 0-1.25.56-1.25 1.25v16c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V8.31l-5.56-5.56H5zM2.25 4A2.75 2.75 0 015 1.25h9.793c.331 0 .65.132.884.366l5.707 5.707c.234.235.366.553.366.884V20A2.75 2.75 0 0119 22.75H5A2.75 2.75 0 012.25 20V4z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 2.241c0-.757.916-1.136 1.451-.6l5.659 5.658c.535.535.156 1.451-.601 1.451H15.1a.85.85 0 01-.85-.85V2.241zm1.5 1.57V7.25h3.44l-3.44-3.44zM7.25 14a.75.75 0 01.75-.75h8a.75.75 0 010 1.5H8a.75.75 0 01-.75-.75z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "download",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47 13.07a.85.85 0 111.11-1.28L11 13V5a1 1 0 012 0v8l1.42-1.23a.85.85 0 111.11 1.28l-3 2.58a.533.533 0 01-.1.06.71.71 0 01-.15.08h-.62a.71.71 0 01-.15-.08.533.533 0 01-.1-.06l-2.94-2.56zM20 14a1 1 0 00-1 1v3a1 1 0 01-1 1H6a1 1 0 01-1-1v-3a1 1 0 10-2 0v3a3 3 0 003 3h12a3 3 0 003-3v-3a1 1 0 00-1-1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "drag",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M21.72 12.72l-2.82 2.82a1.001 1.001 0 01-1.42-1.41L18.6 13H13v5.55l1.1-1.1a1.004 1.004 0 111.42 1.42l-2.83 2.83a1 1 0 01-1.3.08.83.83 0 01-.12-.08l-2.82-2.82a1 1 0 111.41-1.42L11 18.6V13H5.42l1.1 1.1a1.008 1.008 0 11-1.42 1.43L2.28 12.7a1 1 0 010-1.42L5.1 8.46a1 1 0 111.42 1.41L5.38 11H11V5.38L9.88 6.5a1 1 0 11-1.42-1.41l2.83-2.83a.83.83 0 01.23-.15s.06-.06.1-.07a.71.71 0 01.2 0c.059-.018.119-.031.18-.04.06-.005.12-.005.18 0a.71.71 0 01.2 0s.07 0 .1.07a.83.83 0 01.23.15l2.83 2.83a1 1 0 11-1.42 1.41L13 5.38V11h5.6l-1.12-1.11a1.004 1.004 0 011.42-1.42l2.82 2.83a1.002 1.002 0 010 1.42z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "dropper_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 18.77a5 5 0 01.43 1.73 1.84 1.84 0 01-3.68 0 4.16 4.16 0 01.26-1.28 3.66 3.66 0 01.7-1.22 1.23 1.23 0 01.89-.45 1.19 1.19 0 01.89.45c.204.233.375.491.51.77zm11.11-9.25a1 1 0 01-1.57 1.19l-.29-.3-5.29 5.3h-.06a1 1 0 01-.35.2h-.06l-4 1A.67.67 0 018 17a.67.67 0 01-.2 0 .75.75 0 01-.13-.06.8.8 0 01-.33-.22.55.55 0 01-.12-.14.61.61 0 01-.09-.18.75.75 0 01-.13-.16 2 2 0 010-.4l1-4a1 1 0 01.26-.47L13.59 6l-.3-.29a1 1 0 011.19-1.57 4 4 0 115.38 5.38zM16.59 9L15 7.41l-5.1 5.1-.53 2.12 2.12-.53 5.1-5.1zM20 6a2.01 2.01 0 00-4-.38L18.38 8A2 2 0 0020 6z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "earth",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.07a10 10 0 100 20 10 10 0 000-20zm7.9 11.22a2.877 2.877 0 01-.53-.44 1.808 1.808 0 01-.27-.38.63.63 0 01-.08-.28v-.13a.58.58 0 01.25-.32 1.87 1.87 0 01.73-.24v.58c-.003.405-.037.81-.1 1.21zM12.57 4.1c.114.127.211.268.29.42.14.315.212.656.21 1a1.53 1.53 0 01-.11.6.89.89 0 01-.28.37 2.81 2.81 0 01-.61.3 10.25 10.25 0 00-1.55.72 2.78 2.78 0 00-.77.7 2.1 2.1 0 00-.41 1.09v.15c-.012.44.126.87.39 1.22.34.41.809.692 1.33.8a6.29 6.29 0 001.14.16.62.62 0 01.33.11s.05 0 .07.19v.16a3.603 3.603 0 01-.13.82c-.08.32-.19.69-.27 1.1a6.778 6.778 0 00.03 2.48 1.91 1.91 0 010 .4v.16l-.09-.05a1.89 1.89 0 01-.48-.43 7.474 7.474 0 01-.52-.7c-.12-.15-.25-.38-.42-.64a3.47 3.47 0 00-.68-.82 4.38 4.38 0 00-1.33-.72 9.635 9.635 0 01-1-.4 1.7 1.7 0 01-.43-.29c-.09-.08-.12-.12-.13-.15v-.14a1.52 1.52 0 01.1-.51 1.24 1.24 0 01.21-.38c.17-.2.37-.36.62-.65A2.7 2.7 0 008.66 10a4 4 0 00-.89-3.58A3.59 3.59 0 007 5.81a7.89 7.89 0 015-1.74l.57.03zm5.09 13.63a8 8 0 01-12-10.5c.278.078.526.238.71.46a2 2 0 01.51 1.36 2.44 2.44 0 01-.06.52.87.87 0 01-.19.41c-.1.12-.31.3-.58.6a2.93 2.93 0 00-.58 1 3.29 3.29 0 00-.22 1.17 2.52 2.52 0 00.11.75c.14.39.382.735.7 1 .242.201.507.373.79.51.45.22.87.35 1.21.48.273.088.53.22.76.39.126.12.234.259.32.41.13.19.27.44.46.7.266.409.57.79.91 1.14.216.22.462.409.73.56a2.18 2.18 0 001 .28 1.93 1.93 0 00.86-.19c.378-.19.676-.51.84-.9.136-.315.2-.657.19-1a4.1 4.1 0 00-.09-.81 4.07 4.07 0 01-.09-.87 4.917 4.917 0 01.07-.86c.05-.28.15-.6.24-1a4.86 4.86 0 00.19-1.28 2.12 2.12 0 00-.73-1.8 2.43 2.43 0 00-1.39-.55 3.69 3.69 0 01-1-.17l-.09-.05v-.1c0-.1 0-.1.1-.2a3 3 0 011-.52A6.86 6.86 0 0013.81 8c.399-.299.71-.7.9-1.16A3.47 3.47 0 0015 5.47a4.12 4.12 0 00-.1-.86 8 8 0 014.75 5 3.82 3.82 0 00-1.34.53 2.41 2.41 0 00-1 1.38 2.05 2.05 0 00-.1.65c.004.386.097.765.27 1.11.23.453.55.855.94 1.18.307.274.642.515 1 .72a8.13 8.13 0 01-1.76 2.55z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "exit_left",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6v12a3 3 0 01-3 3h-6a1 1 0 010-2h6a1 1 0 001-1V6a1 1 0 00-1-1h-6a1 1 0 110-2h6a3 3 0 013 3zM6.2 13H14a1 1 0 000-2H6.2l2.4-2.4a.85.85 0 00-1.2-1.2l-4 4a.85.85 0 000 1.2l4 4a.85.85 0 001.2-1.2L6.2 13z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "exit_right",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20a1 1 0 01-1 1H7a3 3 0 01-3-3V6a3 3 0 013-3h6a1 1 0 110 2H7a1 1 0 00-1 1v12a1 1 0 001 1h6a1 1 0 011 1zm6.6-8.6l-4-4a.85.85 0 10-1.2 1.2l2.4 2.4H10a1 1 0 000 2h7.8l-2.4 2.4a.85.85 0 001.2 1.2l4-4a.85.85 0 000-1.2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "expand",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4a1 1 0 01-1 1H6.41l2.3 2.29a1.004 1.004 0 01-1.42 1.42L5 6.41V9a1 1 0 01-2 0V4a1 1 0 01.615-.921A1 1 0 014 3h5a1 1 0 011 1zM9 19H6.41l2.3-2.29a1.004 1.004 0 00-1.42-1.42L5 17.59V15a1 1 0 10-2 0v5a1 1 0 00.29.7c.092.09.2.161.32.21A1 1 0 004 21h5a1 1 0 000-2zM20.92 3.62A1 1 0 0020 3h-5a1 1 0 100 2h2.59l-2.3 2.29a1.004 1.004 0 101.42 1.42L19 6.41V9a1 1 0 002 0V4a1.001 1.001 0 00-.08-.38zM20 14a1 1 0 00-1 1v2.59l-2.29-2.3a1.004 1.004 0 00-1.42 1.42l2.3 2.29H15a1 1 0 000 2h5a1 1 0 00.37-.08 1 1 0 00.54-.54A1 1 0 0021 20v-5a1 1 0 00-1-1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "expand_small",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M10.71 14.71L7.41 18H10a1 1 0 010 2H5a1 1 0 01-.37-.08 1 1 0 01-.32-.21A1 1 0 014 19v-5a1 1 0 112 0v2.59l3.29-3.3a1.004 1.004 0 111.42 1.42zm9.21-10.09A1 1 0 0019 4h-5a1 1 0 100 2h2.59l-3.3 3.29a1.004 1.004 0 101.42 1.42L18 7.41V10a1 1 0 002 0V5a1.001 1.001 0 00-.08-.38z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "eye",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.1a4.9 4.9 0 100 9.8 4.9 4.9 0 000-9.8zm0 8a3.1 3.1 0 110-6.2 3.1 3.1 0 010 6.2zm10.69-4.38a8.81 8.81 0 00-1.52-2.2 15.721 15.721 0 00-4-3.07A11.08 11.08 0 0012 4a12.53 12.53 0 00-7.5 3 13.65 13.65 0 00-2.45 2.5 7.86 7.86 0 00-.74 1.25A3.13 3.13 0 001 12c.011.444.117.88.31 1.28a8.81 8.81 0 001.52 2.2 15.72 15.72 0 004 3.07A11.08 11.08 0 0012 20a12.53 12.53 0 007.5-3 13.65 13.65 0 002.5-2.47c.285-.393.532-.811.74-1.25A3.13 3.13 0 0023 12a3.131 3.131 0 00-.31-1.28zm-1.83 1.75a6.931 6.931 0 01-1.17 1.66 13.753 13.753 0 01-3.42 2.66A9.15 9.15 0 0112 18a10.58 10.58 0 01-6.25-2.53 11.72 11.72 0 01-2.08-2.12 5.37 5.37 0 01-.53-.88A1.55 1.55 0 013 12a1.55 1.55 0 01.14-.47 6.93 6.93 0 011.17-1.66 13.75 13.75 0 013.42-2.66A9.15 9.15 0 0112 6a10.58 10.58 0 016.25 2.53 11.72 11.72 0 012.08 2.12c.204.276.382.57.53.88.071.148.119.307.14.47a1.55 1.55 0 01-.14.47z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "eye_crossed_out",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17a5 5 0 005-5 4.9 4.9 0 00-.82-2.72l3.58-3.57a1.005 1.005 0 00-.71-1.714 1.004 1.004 0 00-.71.294l-3.62 3.58A4.9 4.9 0 0012 7.05a5 5 0 00-4.95 5 4.9 4.9 0 00.82 2.72l-3.58 3.52a1.004 1.004 0 001.42 1.42l3.57-3.58A4.9 4.9 0 0012 17zm3.05-5a3 3 0 01-4.37 2.74l4-4c.213.388.34.818.37 1.26zM9 12a3 3 0 014.37-2.74l-4 4A3.05 3.05 0 019 12zm-5.7 4a10.692 10.692 0 01-1.61-2A3.85 3.85 0 011 12a3.13 3.13 0 01.31-1.28 7.86 7.86 0 01.74-1.25A13.65 13.65 0 014.5 7 12.53 12.53 0 0112 4a9.35 9.35 0 012.24.28 1 1 0 11-.48 1.94A7.64 7.64 0 0012 6a9.15 9.15 0 00-4.27 1.21 13.75 13.75 0 00-3.42 2.66 6.93 6.93 0 00-1.17 1.66A1.55 1.55 0 003 12c.058.339.191.66.39.94a8.89 8.89 0 001.31 1.6A1.011 1.011 0 013.3 16zM23 12a3.13 3.13 0 01-.31 1.28 7.867 7.867 0 01-.69 1.25A13.65 13.65 0 0119.5 17a12.53 12.53 0 01-7.5 3 9.347 9.347 0 01-2.24-.28 1 1 0 01.48-1.94A7.643 7.643 0 0012 18a9.15 9.15 0 004.27-1.21 13.753 13.753 0 003.42-2.66 6.931 6.931 0 001.17-1.66A1.55 1.55 0 0021 12a2 2 0 00-.32-.89 6.45 6.45 0 00-1.18-1.46 1 1 0 01-.05-1.41 1 1 0 011.41-.05 8.47 8.47 0 011.56 1.93A4.1 4.1 0 0123 12z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "filter",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M19 4H5a2 2 0 00-2 2v1a3 3 0 001.31 2.41l4.24 2.83a1 1 0 01.45.83V19a2 2 0 003.2 1.6l1.6-1.2A3 3 0 0015 17v-3.93a1 1 0 01.45-.83l4.24-2.83A3.001 3.001 0 0021 7V6a2 2 0 00-2-2zm-4.66 6.57a3 3 0 00-1.34 2.5V17a.999.999 0 01-.4.8L11 19v-5.93a3 3 0 00-1.34-2.5L5.42 7.75A1 1 0 015 7V6h14v1a1 1 0 01-.42.79l-4.24 2.82"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "fire",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.637 1.913c-.047-.743.887-1.256 1.467-.637 1.284 1.371 2.12 2.807 2.45 4.68.262 1.493.196 3.225-.166 5.371.258-.265.5-.575.716-.917.527-.833.853-1.781.906-2.588a.853.853 0 01.586-.755.842.842 0 01.955.318c.584.835 1.117 2.12 1.475 3.468.359 1.352.566 2.858.434 4.148-.369 3.617-3.074 7.34-7.882 7.34-3.99 0-6.51-2.189-7.307-5.022-.782-2.784.131-6.082 2.717-8.297 1.948-1.668 2.851-2.488 3.302-3.35.424-.81.476-1.723.348-3.76zm1.559 1.927c-.028.97-.179 1.766-.577 2.527-.616 1.177-1.795 2.202-3.655 3.795-2.16 1.848-2.868 4.55-2.249 6.75.605 2.152 2.507 3.93 5.863 3.93 3.854 0 6.079-2.943 6.39-5.993.107-1.047-.06-2.36-.392-3.611a13.507 13.507 0 00-.483-1.478c-.19.507-.431.994-.72 1.452-.635 1.002-1.531 1.908-2.611 2.346-.696.282-1.27-.37-1.144-.964.6-2.831.733-4.816.458-6.377a6.785 6.785 0 00-.88-2.377z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "flash",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M21.07 7.17l-4.24-4.24a3 3 0 00-2.12-.88 3 3 0 00-2.12.88L9.91 5.6h-.15a3 3 0 00-2.12.87L4.1 10a7 7 0 109.9 9.9l3.54-3.54a3 3 0 00.87-2.12v-.15l2.67-2.68a3 3 0 000-4.24h-.01zM5.51 18.49a5 5 0 010-7.08l1.75-1.75a.13.13 0 010 .05l7 7h.05l-1.75 1.75a5 5 0 01-7.08 0l.03.03zM16.12 15l-.38.39a.131.131 0 010-.05l-7-7h-.05l.39-.38a1 1 0 01.71-.29.94.94 0 01.7.29l5.66 5.66a.941.941 0 01.29.7 1 1 0 01-.32.68zm3.54-5l-2.12 2.12-5.66-5.66L14 4.34a1 1 0 011.32-.06l-1 1a1.004 1.004 0 101.42 1.42l1-1 1.6 1.6h-.05l-1 1a1.004 1.004 0 101.42 1.42l1-1a1 1 0 01-.05 1.28z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "folder",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6h-3.17a1 1 0 01-.71-.29l-.83-.83A3 3 0 0011.17 4H6a3 3 0 00-3 3v10a3 3 0 003 3h12a3 3 0 003-3V9a3 3 0 00-3-3zm1 11a1 1 0 01-1 1H6a1 1 0 01-1-1V7a1 1 0 011-1h5.17a1 1 0 01.71.29l.83.83a3 3 0 002.12.88H18a1 1 0 011 1v8z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "full_screen",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4a1 1 0 01-1 1H6a1 1 0 00-1 1v3a1 1 0 01-2 0V6a3 3 0 013-3h3a1 1 0 011 1zM9 19H6a1 1 0 01-1-1v-3a1 1 0 10-2 0v3a3 3 0 003 3h3a1 1 0 000-2zm11-5a1 1 0 00-1 1v3a1 1 0 01-1 1h-3a1 1 0 000 2h3a3 3 0 003-3v-3a1 1 0 00-1-1zm-5-9h3a1 1 0 011 1v3a1 1 0 002 0V6a3 3 0 00-3-3h-3a1 1 0 100 2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "gamepad",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M15.84 16.82v-.05c-.09-.12-.17-.25-.25-.37l.25.42zm7.06-2.17v1.24a4.64 4.64 0 01-.41 2 3.18 3.18 0 01-1.36 1.45 3 3 0 01-1.38.36h-.08a3.27 3.27 0 01-1.48-.37 4.35 4.35 0 01-1.11-.85 11.25 11.25 0 01-1.26-1.64l-.25-.37a2.1 2.1 0 00-.68-.65 3.068 3.068 0 00-.93-.37A8.128 8.128 0 0012 15.2a5.7 5.7 0 00-2.88.55 2.1 2.1 0 00-.68.65c-.31.46-.65 1-1.07 1.51a5.25 5.25 0 01-1.55 1.35 3.27 3.27 0 01-1.48.37h-.09a3 3 0 01-1.37-.36 3 3 0 01-1-.88 4.29 4.29 0 01-.75-2.54v-1.14c-.01-1.039.041-2.077.15-3.11a11.32 11.32 0 01.84-3.28v-.07a6.2 6.2 0 012.1-2.74 5.76 5.76 0 013.39-1.14 4.7 4.7 0 011.71.28c.233.105.46.221.68.35l.6.32c.259.147.553.22.85.21h1.08c.304.01.604-.063.87-.21L14 5c.224-.122.454-.232.69-.33a4.7 4.7 0 011.71-.28 5.76 5.76 0 013.39 1.14 6.29 6.29 0 012.11 2.72 11.24 11.24 0 01.83 3.22c.118 1.042.175 2.09.17 3.14v.04zm-2 0a23.78 23.78 0 00-.14-2.83 9.06 9.06 0 00-.68-2.69V9a4.39 4.39 0 00-1.45-1.9 3.8 3.8 0 00-2.21-.75 2.67 2.67 0 00-1 .14 5.332 5.332 0 00-.52.25l-.59.31a3.67 3.67 0 01-1.79.44h-1.06a3.58 3.58 0 01-1.77-.44l-.6-.31a5.33 5.33 0 00-.52-.25 2.67 2.67 0 00-1-.14 3.74 3.74 0 00-2.2.75A4.24 4.24 0 004 9a9.39 9.39 0 00-.69 2.75c-.103.953-.15 1.911-.14 2.87v1.14c-.06.42-.005.849.16 1.24a1 1 0 001 .68 1.14 1.14 0 00.55-.15c.236-.14.445-.319.62-.53a12 12 0 001.27-1.72A4.2 4.2 0 018.08 14a5 5 0 011.48-.6 9.476 9.476 0 012.44-.2 7.41 7.41 0 013.92.84 4.2 4.2 0 011.31 1.25l-.23-.41.28.41c.31.48.63 1 .95 1.36.25.337.567.62.93.83.167.097.357.149.55.15a1.1 1.1 0 00.49-.12 1 1 0 00.34-.31 2.24 2.24 0 00.37-1.35c-.02-.35-.01-.77-.01-1.24v.04zM9 9.46h-.6v-.6a.9.9 0 10-1.8 0v.6H6a.9.9 0 100 1.8h.6v.6a.9.9 0 001.8 0v-.6H9a.9.9 0 100-1.8zm7-1a1.13 1.13 0 101.12 1.13A1.13 1.13 0 0016 8.5v-.04zm2.16 2.25a1.13 1.13 0 10.212 2.25 1.13 1.13 0 00-.212-2.25z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "gear",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9a3 3 0 100 6 3 3 0 000-6zm0 4a1 1 0 110-2 1 1 0 010 2zm8.81-.19a1 1 0 01-.25-.67v-.28a1 1 0 01.25-.67l.64-.72a3 3 0 00.76-2 3.12 3.12 0 00-.4-1.5l-.56-1a3 3 0 00-3.2-1.44l-.94.19h-.21a1.05 1.05 0 01-.49-.13l-.25-.15a1 1 0 01-.45-.44l-.31-.91a3 3 0 00-2.84-2h-1.12A3 3 0 008.6 3.05L8.29 4a1 1 0 01-.45.55l-.24.15a1.13 1.13 0 01-.5.13h-.2L6 4.58a3.05 3.05 0 00-.6-.06A3 3 0 002.75 6l-.56 1a3 3 0 00.36 3.49l.64.72a1 1 0 01.25.67v.28a1 1 0 01-.25.67l-.64.72a3 3 0 00-.76 2 3.12 3.12 0 00.4 1.5l.56 1a3 3 0 003.2 1.44l.94-.19h.2c.171.003.34.047.49.13l.25.15a1 1 0 01.45.55l.32.87a3 3 0 002.84 2h1.12a3 3 0 002.84-2l.31-.91a1 1 0 01.45-.55l.24-.15c.154-.081.326-.126.5-.13h.2l.95.19a3 3 0 003.2-1.44l.56-1a3.12 3.12 0 00.4-1.5 3 3 0 00-.76-2l-.64-.7zm-1.49 1.32l.64.72a1 1 0 01.11 1.17l-.56 1a1 1 0 01-.86.5h-.2l-.94-.19a3 3 0 00-2.11.34l-.24.14a3 3 0 00-1.35 1.65l-.3.92a1 1 0 01-.95.68h-1.12a1 1 0 01-.95-.68l-.3-.92a3 3 0 00-1.35-1.65l-.25-.14a3 3 0 00-2.1-.34l-.94.19h-.2a1 1 0 01-.87-.5l-.55-1a1 1 0 01-.14-.5 1 1 0 01.21-.67l.64-.72a3 3 0 00.76-2v-.28a3 3 0 00-.76-2L4 9.15a1 1 0 01-.25-.67A1 1 0 013.93 8l.56-1a1 1 0 01.86-.5h.2l.94.19a3 3 0 002.1-.34l.25-.14a3 3 0 001.35-1.61l.3-.92a1 1 0 01.95-.68h1.12a1 1 0 01.95.68l.3.92a3 3 0 001.35 1.65l.25.14a3 3 0 002.1.34l.94-.19h.2a1 1 0 01.87.5l.55 1a1 1 0 01-.11 1.17l-.64.72a3 3 0 00-.76 2v.28a3 3 0 00.76 2"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "grops",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 4.5a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zm-2.652-.402a3.75 3.75 0 115.304 5.304 3.75 3.75 0 01-5.304-5.304zM4.75 8.5a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm-1.945-.695a2.75 2.75 0 113.89 3.89 2.75 2.75 0 01-3.89-3.89zM18.75 8.5a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm-1.945-.695a2.75 2.75 0 113.89 3.89 2.75 2.75 0 01-3.89-3.89zM11.75 13.5a4.252 4.252 0 00-3.358 1.644h6.716A4.25 4.25 0 0011.75 13.5zm3.96 3.144L15.928 19H7.572l.218-2.357h7.92zm-8.818-1.971a3.748 3.748 0 00-5.197.904A3.75 3.75 0 001 17.75v2c0 .414.336.75.75.75h20a.75.75 0 00.75-.75v-2a3.75 3.75 0 00-5.892-3.078 5.75 5.75 0 00-9.716 0zM17.5 19H21v-1.25a2.25 2.25 0 00-3.749-1.678c.162.532.249 1.096.249 1.678V19zM6 19v-1.25c0-.582.087-1.146.249-1.678A2.249 2.249 0 002.5 17.75V19H6z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "hamburger_menu",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6a1 1 0 011-1h16a1 1 0 110 2H4a1 1 0 01-1-1zm17 5H4a1 1 0 000 2h16a1 1 0 000-2zm0 6H4a1 1 0 000 2h16a1 1 0 000-2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "hand_pointer",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17v-2.53a4.71 4.71 0 00-.65-2.55 3.859 3.859 0 00-1.19-1.19 6.69 6.69 0 00-2.07-.84c-.68-.18-1.31-.3-1.8-.45A8.81 8.81 0 0013 9.13V5a3 3 0 00-6 0v5.59l-1.71 1.7a4.85 4.85 0 00-1 1.64 6 6 0 00-.43 2.22 4.93 4.93 0 001.44 3.56l1.7 1.7a2 2 0 001.41.59H16a4 4 0 004-4v-1zm-4 3H8.41l-1.7-1.71a2.86 2.86 0 01-.86-2.14 3.84 3.84 0 01.29-1.49c.126-.35.32-.674.57-.95l.29-.3V15a1 1 0 102 0V5a1 1 0 012 0v5a1.004 1.004 0 00.05.38v.07c.044.095.1.182.17.26A1.001 1.001 0 0012 11c.588.036 1.17.147 1.73.33.57.17 1.14.29 1.67.42a4.57 4.57 0 011.92.81c.216.18.385.41.49.67.146.396.21.818.19 1.24V18a2 2 0 01-2 2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "hash",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15h-4V9h4a1 1 0 100-2h-4V3a1 1 0 00-2 0v4H9V3a1 1 0 00-2 0v4H3a1 1 0 000 2h4v6H3a1 1 0 000 2h4v4a1 1 0 102 0v-4h6v4a1 1 0 002 0v-4h4a1 1 0 000-2zM9 15V9h6v6H9z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "headphones",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.76V11a8 8 0 00-16 0v1.76A4.5 4.5 0 006.5 21H7a1 1 0 001-1v-7a1 1 0 00-1-1h-.5a4.212 4.212 0 00-.5.05V11a6 6 0 0112 0v1.05a4.212 4.212 0 00-.5-.05H17a1 1 0 00-1 1v7a1 1 0 001 1h.5a4.5 4.5 0 002.5-8.24zM4 16.5a2.5 2.5 0 012-2.45V19a2.5 2.5 0 01-2-2.5zM18 19v-4.9a2.5 2.5 0 010 4.9z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "headphones_with_microphone_copy",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M21.33 12.92A3.908 3.908 0 0020 10 7.998 7.998 0 007.722 3.244 8 8 0 004 10l-.22.19a4.26 4.26 0 000 5.76 3.83 3.83 0 002.79 1.23H7a1 1 0 00.71-.29 1 1 0 00.29-.67V10a1 1 0 00-1-1h-.42a4.229 4.229 0 00-.5.05 5.87 5.87 0 01.5-1.62 6 6 0 0110.84 0 5.87 5.87 0 01.5 1.62 4.229 4.229 0 00-.5-.05H17a1 1 0 00-1 1v5.83a1.002 1.002 0 00.29.71 1.001 1.001 0 00.71.29h.42c.195-.005.389-.025.58-.06V19a1 1 0 01-1 1h-1a2.498 2.498 0 00-2.5-3h-2a2.5 2.5 0 000 5H17a3 3 0 003-3v-3a.697.697 0 000-.14 3.87 3.87 0 001.33-2.94zm-16.66.19a2.2 2.2 0 01.58-1.51 1.91 1.91 0 01.75-.49v4a2 2 0 01-.75-.48 2.23 2.23 0 01-.58-1.52zM12 20h-.5a.5.5 0 010-1h2a.5.5 0 010 1H12zm6-5.27V11.1a1.9 1.9 0 010 3.63z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "heart",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M16.44 3.22a5.53 5.53 0 00-3.68 1.4 1.14 1.14 0 01-1.52 0A5.55 5.55 0 002 8.77c0 4.75 7.3 10.31 9.42 11.83a1 1 0 001.16 0C14.7 19.08 22 13.52 22 8.77a5.56 5.56 0 00-5.56-5.55zM12 18.54c-4.07-3-8-7.09-8-9.77a3.56 3.56 0 015.91-2.66 3.13 3.13 0 004.18 0A3.56 3.56 0 0120 8.77c0 2.68-3.93 6.75-8 9.77z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "i_info",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M14.217 9.618c0 .616-.198 1.68-.594 3.19-.396 1.496-.594 2.479-.594 2.948 0 .455.066.682.198.682.088 0 .425-.14 1.012-.418l.264-.132.374.77c-.132.117-.308.264-.528.44-.22.176-.63.418-1.232.726-.601.293-1.159.44-1.672.44-.513 0-.917-.154-1.21-.462-.293-.323-.44-.748-.44-1.276 0-.543.183-1.496.55-2.86.367-1.379.55-2.273.55-2.684 0-.616-.19-1.195-.572-1.738l-.198-.264.022-.286c.777-.22 2.039-.33 3.784-.33.19.22.286.638.286 1.254zm-2.508-3.652c-.293-.293-.44-.682-.44-1.166 0-.484.198-.91.594-1.276.41-.367.88-.55 1.408-.55.528 0 .939.147 1.232.44.293.293.44.682.44 1.166 0 .47-.213.887-.638 1.254-.41.367-.873.55-1.386.55-.513 0-.917-.14-1.21-.418z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "info",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8a1 1 0 011-1 1 1 0 01.85.51A.91.91 0 0113 8a1 1 0 01-2 0zm11 4a10 10 0 11-20 0 10 10 0 0120 0zm-2 0a8 8 0 10-16 0 8 8 0 0016 0zm-7 2v-3a1 1 0 00-1-1h-1a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 000-2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "label",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M19 2h-6.17a3 3 0 00-2.12.88l-8 8a3 3 0 000 4.24l6.17 6.17a3 3 0 004.24 0l8-8a3 3 0 00.88-2.12V5a3 3 0 00-3-3zm1 9.17a1 1 0 01-.29.71l-8 8a1.002 1.002 0 01-1.42 0l-6.17-6.17a1 1 0 010-1.42l8-8a1 1 0 01.71-.29H19a1 1 0 011 1v6.17zM15 6a3 3 0 100 6 3 3 0 000-6zm0 4a1 1 0 110-2 1 1 0 010 2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "lightning",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M21.844 9.53a1 1 0 00-.88-.53h-7V2a1 1 0 00-1.83-.55l-8 12a1 1 0 000 1 1 1 0 00.83.55h7v7a1 1 0 001.83.55l8-12a1 1 0 00.05-1.02zm-7.88 9.17V14a1 1 0 00-1-1h-6.13l5.13-7.7V10a1 1 0 001 1h6.13l-5.13 7.7z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "link",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16a5 5 0 01-1.46 3.54L10.12 21a5 5 0 01-7.07-7.07l1.41-1.42A5 5 0 018 11a1 1 0 010 2 3 3 0 00-2.12.88l-1.42 1.41a3.005 3.005 0 004.25 4.25l1.41-1.42A3 3 0 0011 16a1 1 0 012 0zm9.41-9.41a5 5 0 00-8.53-3.54l-1.42 1.41A5 5 0 0011 8a1 1 0 002 0 3 3 0 01.88-2.12l1.41-1.42a3.005 3.005 0 114.25 4.25l-1.42 1.41A3 3 0 0116 11a1 1 0 000 2 5 5 0 003.54-1.46L21 10.12a5 5 0 001.41-3.53zM8.29 15.71a1 1 0 001.42 0l6-6a1.004 1.004 0 00-1.42-1.42l-6 6a1 1 0 000 1.42z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "list",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12a1 1 0 01-1 1H9a1 1 0 010-2h6a1 1 0 011 1zm-4 3H9a1 1 0 000 2h3a1 1 0 000-2zm9-10v14a3 3 0 01-3 3H6a3 3 0 01-3-3V5a3 3 0 013-3h12a3 3 0 013 3zm-7 1a1 1 0 001-1V4H9v1a1 1 0 001 1h4zm5-1a1 1 0 00-1-1h-1v1a3 3 0 01-3 3h-4a3 3 0 01-3-3V4H6a1 1 0 00-1 1v14a1 1 0 001 1h12a1 1 0 001-1V5z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "list_checkmarks",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4a.9.9 0 010 1.3L5.7 7.58a1 1 0 01-.52.24h-.12a.85.85 0 01-.22 0 .53.53 0 01-.12 0 .87.87 0 01-.18-.11l-.12-.08L3.24 6.4a.91.91 0 111.28-1.28l.54.55L6.7 4A.9.9 0 018 4zm-1.3 6l-1.64 1.67-.54-.55a.91.91 0 00-1.28 1.28l1.18 1.18.12.08a.87.87 0 00.18.11h.12a.81.81 0 00.22 0h.12a1 1 0 00.52-.24L8 11.3A.92.92 0 006.7 10zm0 6l-1.64 1.67-.54-.55a.91.91 0 10-1.28 1.28l1.18 1.18.12.08a.87.87 0 00.18.11h.12a.81.81 0 00.22 0h.12a1 1 0 00.52-.24L8 17.3A.92.92 0 006.7 16zM11 7h8.5a1 1 0 100-2H11a1 1 0 100 2zm8.5 10H11a1 1 0 100 2h8.5a1 1 0 000-2zm0-6H11a1 1 0 000 2h8.5a1 1 0 000-2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "loading",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M5.167 16.423c-.21 0-.412-.041-.56-.114-.149-.072-.232-.17-.232-.273 0-.103.083-.201.232-.274.148-.072.35-.113.56-.113h12.666c.21 0 .412.04.56.113.149.073.232.171.232.274 0 .102-.083.2-.232.273-.148.073-.35.114-.56.114H5.167zm0 1.547h12.666c.21 0 .412-.04.56-.113.149-.073.232-.171.232-.274 0-.102-.083-.2-.232-.273a1.314 1.314 0 00-.56-.114H5.167c-.21 0-.412.041-.56.114-.149.072-.232.17-.232.273 0 .103.083.201.232.274.148.073.35.113.56.113zm0 1.548h12.666c.21 0 .412-.04.56-.114.149-.072.232-.17.232-.273 0-.103-.083-.201-.232-.274a1.315 1.315 0 00-.56-.113H5.167c-.21 0-.412.04-.56.113-.149.073-.232.171-.232.274 0 .103.083.2.232.273.148.073.35.114.56.114zm0 1.547h12.666c.21 0 .412-.04.56-.113.149-.073.232-.17.232-.273 0-.103-.083-.201-.232-.274a1.315 1.315 0 00-.56-.113H5.167c-.21 0-.412.04-.56.113-.149.073-.232.17-.232.274 0 .102.083.2.232.273.148.073.35.113.56.113zm5.745-7.651L6.945 9.436a.666.666 0 01.939-.94l2.836 2.85V3.662A.664.664 0 0111.382 3a.66.66 0 01.66.663v7.682l2.837-2.85a.663.663 0 11.939.941l-3.967 3.978a.663.663 0 01-.94 0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "location",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7a3 3 0 100 6 3 3 0 000-6zm0 4a1 1 0 110-2 1 1 0 010 2zm0-9a8 8 0 00-8 8c0 6 5.37 10.51 7.31 12.36a1 1 0 001.38 0C14.63 20.51 20 16 20 10a8 8 0 00-8-8zm0 18.26C10 18.34 6 14.54 6 10a6 6 0 1112 0c0 4.54-3.95 8.34-6 10.26z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "lock_closed",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7h-1V6a4 4 0 10-8 0v1H7a3 3 0 00-3 3v8a3 3 0 003 3h10a3 3 0 003-3v-8a3 3 0 00-3-3zm-7-1a2 2 0 114 0v1h-4V6zm8 12a1 1 0 01-1 1H7a1 1 0 01-1-1v-8a1 1 0 011-1h10a1 1 0 011 1v8zm-4.5-4.52a1.509 1.509 0 01-.7 1.27v.73a.8.8 0 11-1.6 0v-.73a1.509 1.509 0 01-.7-1.27 1.5 1.5 0 113 0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "lock_opened",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7h-7V5a4 4 0 00-8 0 1 1 0 002 0 2 2 0 114 0v2H7a3 3 0 00-3 3v8a3 3 0 003 3h10a3 3 0 003-3v-8a3 3 0 00-3-3zm1 11a1 1 0 01-1 1H7a1 1 0 01-1-1v-8a1 1 0 011-1h10a1 1 0 011 1v8zm-4.5-4.52a1.509 1.509 0 01-.7 1.27v.73a.8.8 0 11-1.6 0v-.73a1.509 1.509 0 01-.7-1.27 1.5 1.5 0 013 0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.88 9.491l2.822 9.88a1.35 1.35 0 102.596-.742L19.473 5.24c-.417-1.457-2.462-1.512-2.956-.079l-3.55 10.297-2.51-6.901c-.495-1.36-2.419-1.36-2.914 0l-2.74 7.533-1.596-3.193a1.35 1.35 0 00-2.414 1.208l2.792 5.584c.608 1.217 2.378 1.115 2.843-.164L9 12.45l2.538 6.98c.5 1.373 2.446 1.357 2.922-.024l3.42-9.915z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "magnifier",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M21.71 20.29l-4.4-4.39A7.9 7.9 0 0019 11a8 8 0 10-8 8 7.9 7.9 0 004.9-1.69l4.39 4.4a1.004 1.004 0 101.42-1.42zm-14.95-5A6 6 0 1111 17a6 6 0 01-4.24-1.76v.05z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "magnifier_new_design",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.64961 6.99998C1.64961 4.04525 4.04489 1.64998 6.99961 1.64998C9.95433 1.64998 12.3496 4.04525 12.3496 6.99998C12.3496 9.9547 9.95433 12.35 6.99961 12.35C4.04489 12.35 1.64961 9.9547 1.64961 6.99998ZM6.99961 0.349976C3.32692 0.349976 0.349609 3.32728 0.349609 6.99998C0.349609 10.6727 3.32692 13.65 6.99961 13.65C8.60187 13.65 10.0718 13.0833 11.2199 12.1395L13.54 14.4596C13.7938 14.7134 14.2054 14.7134 14.4592 14.4596C14.7131 14.2058 14.7131 13.7942 14.4592 13.5404L12.1391 11.2202C13.083 10.0721 13.6496 8.60224 13.6496 6.99998C13.6496 3.32728 10.6723 0.349976 6.99961 0.349976Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "magnifier_minus",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M21.71 20.29l-4.4-4.39A7.9 7.9 0 0019 11a8 8 0 10-8 8 7.9 7.9 0 004.9-1.69l4.39 4.4a1.004 1.004 0 101.42-1.42zm-14.95-5A6 6 0 1111 17a6 6 0 01-4.24-1.76v.05zM14 11a1 1 0 01-1 1H9a1 1 0 010-2h4a1 1 0 011 1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "magnifier_plus",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M21.71 20.29l-4.4-4.39A7.9 7.9 0 0019 11a8 8 0 10-8 8 7.9 7.9 0 004.9-1.69l4.39 4.4a1.004 1.004 0 101.42-1.42zm-14.95-5A6 6 0 1111 17a6 6 0 01-4.24-1.76v.05zM14.25 11a1 1 0 01-1 1H12v1.25a1 1 0 01-2 0V12H8.75a1 1 0 010-2H10V8.75a1 1 0 012 0V10h1.25a1 1 0 011 1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "mail",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M19 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-3-3zm1 13a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h14a1 1 0 011 1v10zm-2.22-7.62a1 1 0 01-.16 1.4l-3.75 3a3 3 0 01-3.74 0l-3.75-3a1 1 0 011.24-1.56l3.76 3a1 1 0 001.24 0l3.76-3a1 1 0 011.4.16z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "market",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.054 11.272c-.04.043-.083.086-.127.127-.509.472-1.229.747-2.176.837v6.791c0 .746.56 1.351 1.25 1.351h12c.69 0 1.25-.605 1.25-1.351v-6.802c-1.019-.128-1.726-.518-2.2-1.022-.504.609-1.316 1.067-2.55 1.067-1.212 0-2.016-.441-2.522-1.034-.503.584-1.295 1.034-2.478 1.034-1.158 0-1.942-.431-2.447-.998zm4.217-2.015l1.46.04h.02v-.01l.002.03a1.553 1.553 0 00.197.63c.165.287.54.7 1.551.7 1.01 0 1.386-.413 1.551-.7a1.559 1.559 0 00.199-.66v.007s0 .002.75.002h.75V9.28l.002.023a1.323 1.323 0 00.223.588c.204.294.708.757 2.025.757h.75v8.378c0 1.642-1.231 2.973-2.75 2.973h-12c-1.519 0-2.75-1.331-2.75-2.973v-8.378h.75c1.174 0 1.71-.259 1.95-.48.21-.196.3-.465.3-.872l1.48-.04.019-.001v-.007l.003.032a1.738 1.738 0 00.227.655c.185.31.573.713 1.521.713s1.335-.404 1.521-.713a1.735 1.735 0 00.23-.689v.008l.02.002zM7.75 9.25v-.002.002z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 16.865c0-1.642 1.231-2.973 2.75-2.973s2.75 1.331 2.75 2.973V22h-5.5v-5.135zM12 15.514c-.69 0-1.25.605-1.25 1.35v3.514h2.5v-3.513c0-.746-.56-1.351-1.25-1.351zM1.251 4.973C1.251 3.331 2.482 2 4.001 2h3.75v7.297h-.75.75v.023a1.826 1.826 0 01-.008.142 3.257 3.257 0 01-.419 1.346c-.459.794-1.333 1.462-2.823 1.462s-2.364-.668-2.824-1.462a3.257 3.257 0 01-.426-1.488v-.021s0-.002.75-.002h-.75V4.973zm1.5 4.316l.002.03c.003.031.008.084.021.15.026.136.078.31.175.48.166.286.542.7 1.552.7s1.386-.414 1.551-.7a1.556 1.556 0 00.199-.66V3.622h-2.25c-.69 0-1.25.605-1.25 1.351v4.316z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.251 2h6.5v7.297h-.75.75v.023l-.001.035a3.17 3.17 0 01-.054.445c-.052.27-.157.636-.371 1.008-.46.794-1.334 1.462-2.824 1.462-1.49 0-2.364-.668-2.824-1.462a3.257 3.257 0 01-.426-1.488v-.021s0-.002.75-.002h-.75V2zm1.5 7.289l.002.03c.003.031.008.084.021.15.026.136.078.31.175.48.166.286.542.7 1.552.7s1.386-.414 1.552-.7a1.559 1.559 0 00.198-.66V3.622h-3.5v5.667z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.251 2h6.5v7.297h-.75.75v.023l-.001.035a3.17 3.17 0 01-.054.445c-.052.27-.157.636-.371 1.008-.46.794-1.334 1.462-2.824 1.462-1.49 0-2.364-.668-2.823-1.462a3.256 3.256 0 01-.427-1.488v-.021s0-.002.75-.002h-.75V2zm1.5 7.289l.002.03a1.553 1.553 0 00.197.63c.165.286.54.7 1.551.7 1.01 0 1.386-.414 1.551-.7a1.559 1.559 0 00.199-.66V3.622h-3.5v5.667z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.251 2h3.75c1.519 0 2.75 1.331 2.75 2.973v4.324h-.75.75v.023l-.001.035a3.17 3.17 0 01-.054.445c-.052.27-.157.636-.371 1.008-.46.794-1.334 1.462-2.824 1.462-1.49 0-2.364-.668-2.824-1.462a3.256 3.256 0 01-.426-1.488v-.021s0-.002.75-.002h-.75V2zm1.5 7.289l.002.03a1.553 1.553 0 00.197.63c.165.286.54.7 1.551.7 1.01 0 1.386-.414 1.551-.7a1.559 1.559 0 00.199-.66V4.973c0-.746-.56-1.351-1.25-1.351h-2.25v5.667z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "medical_cross",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8h-3V5a3 3 0 00-3-3h-2a3 3 0 00-3 3v3H5a3 3 0 00-3 3v2a3 3 0 003 3h3v3a3 3 0 003 3h2a3 3 0 003-3v-3h3a3 3 0 003-3v-2a3 3 0 00-3-3zm1 5a1 1 0 01-1 1h-4a1 1 0 00-1 1v4a1 1 0 01-1 1h-2a1 1 0 01-1-1v-4a1 1 0 00-1-1H5a1 1 0 01-1-1v-2a1 1 0 011-1h4a1 1 0 001-1V5a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1h4a1 1 0 011 1v2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "microphone",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M13 18.14V20h2a1 1 0 010 2H9a1 1 0 010-2h2v-1.86a6.45 6.45 0 01-5.44-6.36 1 1 0 112 0 4.44 4.44 0 108.88 0 1 1 0 012 0A6.45 6.45 0 0113 18.14zM9 12V6a3 3 0 116 0v6a3 3 0 01-6 0zm2-6v6a1 1 0 002 0V6a1 1 0 00-2 0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "minus_round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16 8 8 0 010 16zm3-8a1 1 0 01-1 1h-4a1 1 0 010-2h4a1 1 0 011 1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "monitor_2_copy",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M19.09 2.61h-14a3 3 0 00-3 3v9a3 3 0 003 3h6v2h-4a1 1 0 000 2h10a1 1 0 000-2h-4v-2h6a3 3 0 003-3v-9a3 3 0 00-3-3zm1 12a1 1 0 01-1 1h-14a1 1 0 01-1-1v-9a1 1 0 011-1h14a1 1 0 011 1v9zm-3-7a1 1 0 01-1 1h-8a1 1 0 010-2h8a1 1 0 011 1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "monitor_phone_copy_2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9h-1V4.73A2.73 2.73 0 0016.27 2H3.73A2.73 2.73 0 001 4.73v7.54A2.73 2.73 0 003.73 15H9v2H5a1 1 0 000 2h9a3 3 0 003 3h3a3 3 0 003-3v-7a3 3 0 00-3-3zM3.73 13a.73.73 0 01-.73-.73V4.73A.73.73 0 013.73 4h12.54a.73.73 0 01.73.73V9a3 3 0 00-3 3v1H3.73zM11 17v-2h3v2h-3zm10 2a1 1 0 01-1 1h-3a1 1 0 01-1-1v-7a1 1 0 011-1h3a1 1 0 011 1v7zm-1-1a1 1 0 01-1 1h-1a.95.95 0 010-1.9h1a1 1 0 011 .9z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "mouse",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.08V3a1 1 0 00-2 0v2.08A7 7 0 005 12v4a7 7 0 1014 0v-4a7 7 0 00-6-6.92zM17 16a5 5 0 11-10 0v-4a5 5 0 1110 0v4zm-4-6v3a1 1 0 01-2 0v-3a1 1 0 012 0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "music",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6a1 1 0 00-1-1H9a1 1 0 00-1 1v8.18A3 3 0 1010 17V7h8v7.18A3 3 0 1020 17V6zM7 18a1 1 0 110-2 1 1 0 010 2zm10 0a1 1 0 110-2 1 1 0 010 2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "network",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14a4 4 0 00-2.92 1.28l-3.31-2a3.73 3.73 0 000-2.58l3.31-2A4 4 0 1012 6c0 .338.043.674.13 1L8.66 9A3.93 3.93 0 006 8a4 4 0 000 8 3.93 3.93 0 002.66-1l3.47 2c-.087.326-.13.662-.13 1a4 4 0 104-4zm0-10a2 2 0 110 4 2 2 0 010-4zM6 14a2 2 0 110-4 2 2 0 010 4zm10 6a2 2 0 110-4 2 2 0 010 4z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "no_sound",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.74a1.071 1.071 0 00-.07-.19v-.06c0-.06-.06-.06-.08-.09a.67.67 0 00-.14-.15l-.15-.11a.999.999 0 00-.18-.08h-.2L12 5h-.26l-.19.07h-.06L6.72 8H5a3 3 0 00-3 3v2a3 3 0 003 3h1.72l4.77 2.86h.06l.19.07h.57a.906.906 0 00.18-.08l.15-.11a.67.67 0 00.14-.15s.06-.05.08-.09c.02-.04 0 0 0-.06.03-.061.053-.125.07-.19a1.282 1.282 0 000-.19L13 18V5.93a1.282 1.282 0 000-.19zM4 13v-2a1 1 0 011-1h2.26l.19-.07h.06L11 7.77v8.46l-3.49-2.09h-.06l-.19-.07H5A1.002 1.002 0 014 13zm15.41-1L21 10.46A1.032 1.032 0 1019.54 9L18 10.59 16.46 9A1.032 1.032 0 1015 10.46L16.59 12 15 13.54A1.032 1.032 0 1016.46 15L18 13.41 19.54 15A1.032 1.032 0 1021 13.54L19.41 12z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "notes_vertical",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8a1 1 0 01-1 1h-6a1 1 0 010-2h6a1 1 0 011 1zm-1 3h-6a1 1 0 000 2h6a1 1 0 000-2zm-3 4h-3a1 1 0 000 2h3a1 1 0 000-2zm9-10v14a3 3 0 01-3 3H7a3 3 0 01-3-3v-1H3a1 1 0 010-2h1V8H3a1 1 0 010-2h1V5a3 3 0 013-3h12a3 3 0 013 3zm-2 0a1 1 0 00-1-1H7a1 1 0 00-1 1v14a1 1 0 001 1h12a1 1 0 001-1V5z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "package",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm1 3v1h-3V5h2a1 1 0 011 1zm-9-1h4v3a1 1 0 01-1 1h-2a1 1 0 01-1-1V5zM6 5h2v2H5V6a1 1 0 011-1zm13 13a1 1 0 01-1 1H6a1 1 0 01-1-1V9h3a1 1 0 00.17 0A3 3 0 0011 11h2a3 3 0 002.83-2A1 1 0 0016 9h3v9zm-3-3a1 1 0 010 2H8a1 1 0 010-2h8z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "paper",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M20.12 7.71l-4.83-4.83A3 3 0 0013.17 2H6a3 3 0 00-3 3v14a3 3 0 003 3h12a3 3 0 003-3V9.83a3 3 0 00-.88-2.12zM18.59 9H15a1 1 0 01-1-1V4.41L18.59 9zM18 20H6a1 1 0 01-1-1V5a1 1 0 011-1h6v4a3 3 0 003 3h4v8a1 1 0 01-1 1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "paperclip",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M21.87 9.29a6 6 0 01-1.75 4.21l-5.1 5a1 1 0 01-1.34 0 1 1 0 010-1.35l5.1-5a4.078 4.078 0 000-5.77A4.07 4.07 0 0013 6.4l-8.27 8.29a2.4 2.4 0 103.39 3.39l2.36-2.35 5.93-5.94a.69.69 0 00.21-.5.729.729 0 00-.21-.52.75.75 0 00-.51-.21.71.71 0 00-.51.21l-4.14 4.15-3.56 3.54a1 1 0 01-1.34 0 .94.94 0 010-1.33l5.9-5.9L14 7.44a2.63 2.63 0 014.28 2.868 2.57 2.57 0 01-.57.842l-8.24 8.27a4.3 4.3 0 01-7.34-3 4.32 4.32 0 011.26-3l8.28-8.28a6 6 0 0110.2 4.23v-.08z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "parking_circle",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.51a3.3 3.3 0 00-1.32-2.6A4.4 4.4 0 0012 7H9a1 1 0 00-1 1v8a1 1 0 102 0v-2h2a4.34 4.34 0 002.67-.9A3.3 3.3 0 0016 10.51zm-2.55 1A2.42 2.42 0 0112 12h-2V9h2a2.48 2.48 0 011.44.47 1.27 1.27 0 01.55 1 1.311 1.311 0 01-.55 1.05l.01-.01zM16 16a1 1 0 01-1 1h-1a1 1 0 010-2h1a1 1 0 011 1zM12 2a10 10 0 100 20 10 10 0 000-20zm5.66 15.66A8 8 0 116.34 6.352 8 8 0 0117.66 17.66z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "pause",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2h5v20h-5V2zM5 2h5v20H5V2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "pen",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.217 3.823l3.96 3.96a1.25 1.25 0 010 1.768l-9.94 9.938a1.25 1.25 0 01-.572.327l-5.327 1.367a1.25 1.25 0 01-1.521-1.521l1.367-5.327a1.25 1.25 0 01.327-.573l9.938-9.939a1.25 1.25 0 011.768 0zm-.884 1.238L5.62 14.774l-1.245 4.851 4.85-1.245 9.714-9.713-3.606-3.606z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.688 8.313a.5.5 0 010 .707l-6 6a.5.5 0 11-.707-.707l6-6a.5.5 0 01.707 0zM6.98 16.314a.5.5 0 01.707 0l2 2a.5.5 0 01-.707.707l-2-2a.5.5 0 010-.707zM17.47 1.47a.75.75 0 011.061 0l4 4a.75.75 0 01-1.06 1.06l-4-4a.75.75 0 010-1.06z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "pensil",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M19.29 4.88l-.17-.17a3 3 0 00-4.24 0l-9.59 9.58a1 1 0 00-.26.47l-1 4A1 1 0 005.24 20l4-1a1 1 0 00.47-.26l9.58-9.59a3 3 0 000-4.24v-.03zM8.49 17.1l-2.12.53.53-2.12 6.58-6.58 1.59 1.59-6.58 6.58zm9.39-9.39l-1.4 1.39-1.58-1.58 1.39-1.4a1 1 0 011.42 0l.17.17a1.001 1.001 0 010 1.42z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "percent_symbol",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8a3 3 0 10-6 0 3 3 0 006 0zM7 8a1 1 0 112 0 1 1 0 01-2 0zm9 5a3 3 0 100 5.999A3 3 0 0016 13zm0 4a1 1 0 110-2 1 1 0 010 2zm1.71-9.29l-10 10a1.004 1.004 0 11-1.42-1.42l10-10a1.004 1.004 0 011.42 1.42z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "phone_checkmark",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M19.94 17.31a3 3 0 00-.88-2.1l-.26-.27a4.54 4.54 0 00-3.21-1.33 4.629 4.629 0 00-2 .47l-.83.42a7.469 7.469 0 01-1.92-1.37 7.13 7.13 0 01-1.36-1.91l.41-.83A4.52 4.52 0 009 5.15l-.26-.26A3 3 0 006.65 4h-.79a3 3 0 00-3 3v.07a17.54 17.54 0 00.76 4.76 13 13 0 003.15 5.32 12.81 12.81 0 005.31 3.16c1.546.48 3.152.739 4.77.77h.08a3 3 0 003-3v-.81l.01.04zm-3.01 1.8a15.241 15.241 0 01-4.22-.67 11 11 0 01-4.5-2.67 10.87 10.87 0 01-2.65-4.5 15.24 15.24 0 01-.67-4.22V7a1 1 0 011-1h.79a1 1 0 01.71.3l.26.26a2.52 2.52 0 01.47 2.92l-.63 1.25a1 1 0 000 .83 9.23 9.23 0 002 3 9 9 0 003 2 .999.999 0 00.82 0l1.26-.63a2.62 2.62 0 011.12-.26 2.58 2.58 0 011.8.74l.26.27a1 1 0 01.29.7v.79a1 1 0 01-1.11.94zm4.78-13.4l-4 4a1 1 0 01-1.42 0l-2-2a1.004 1.004 0 111.42-1.42L17 7.59l3.29-3.3a1.004 1.004 0 011.42 1.42z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "phone_minus",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.31a3 3 0 00-.88-2.1l-.26-.27a4.54 4.54 0 00-3.21-1.33 4.63 4.63 0 00-2 .47l-.83.42a7.469 7.469 0 01-1.92-1.37 7.13 7.13 0 01-1.36-1.91l.41-.83a4.52 4.52 0 00-.85-5.23l-.26-.26A3 3 0 006.69 4H5.9a3 3 0 00-3 3v.07a17.54 17.54 0 00.76 4.76 13 13 0 003.15 5.32 12.811 12.811 0 005.31 3.16c1.546.48 3.152.739 4.77.77H17a3 3 0 003-3v-.81.04zm-3 1.8a15.242 15.242 0 01-4.22-.67 11 11 0 01-4.5-2.67 10.87 10.87 0 01-2.65-4.5 15.24 15.24 0 01-.73-4.22V7a1 1 0 011-1h.79a1 1 0 01.71.3l.26.26a2.52 2.52 0 01.47 2.92l-.63 1.26a1 1 0 000 .83 9.23 9.23 0 002 3 9.001 9.001 0 003 2 1 1 0 00.82 0l1.26-.63a2.54 2.54 0 012.91.48l.27.27a1 1 0 01.29.7v.79a1 1 0 01-1.05.93zM21 7a1 1 0 01-1 1h-4a1 1 0 010-2h4a1 1 0 011 1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "phone_plus",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.31a3 3 0 00-.88-2.1l-.26-.27a4.54 4.54 0 00-3.21-1.33 4.63 4.63 0 00-2 .47l-.83.42a7.469 7.469 0 01-1.92-1.37 7.13 7.13 0 01-1.36-1.91l.41-.83a4.52 4.52 0 00-.85-5.23l-.26-.26A3 3 0 006.69 4H5.9a3 3 0 00-3 3v.07a17.54 17.54 0 00.76 4.76 13 13 0 003.15 5.32 12.811 12.811 0 005.31 3.16c1.546.48 3.152.739 4.77.77H17a3 3 0 003-3v-.81.04zm-3 1.8a15.242 15.242 0 01-4.22-.67 11 11 0 01-4.5-2.67 10.87 10.87 0 01-2.65-4.5 15.24 15.24 0 01-.73-4.22V7a1 1 0 011-1h.79a1 1 0 01.71.3l.26.26a2.52 2.52 0 01.47 2.92l-.63 1.26a1 1 0 000 .83 9.23 9.23 0 002 3 9.001 9.001 0 003 2 1 1 0 00.82 0l1.26-.63a2.54 2.54 0 012.91.48l.27.27a1 1 0 01.29.7v.79a1 1 0 01-1.05.93zM21.26 7a1 1 0 01-1 1H19v1.25a1 1 0 11-2 0V8h-1.24a1 1 0 010-2H17V4.75a1 1 0 012 0V6h1.26a1 1 0 011 1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "phone_rings",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1 17.35a3 3 0 00-.87-2.09L19 15a4.61 4.61 0 00-3.25-1.35 4.549 4.549 0 00-2 .48l-.85.42a7.149 7.149 0 01-1.95-1.39 7.3 7.3 0 01-1.38-2l.42-.85a4.5 4.5 0 00.49-2 4.61 4.61 0 00-1.42-3.25l-.28-.27a3 3 0 00-2.12-.88h-.84a3 3 0 00-3 3V7a18 18 0 00.76 4.84 13.18 13.18 0 003.2 5.41 13.12 13.12 0 005.4 3.21c1.57.48 3.199.739 4.84.77h.07a3 3 0 003-3v-.84l.01-.04zm-3 1.86a15.362 15.362 0 01-4.28-.68 11.21 11.21 0 01-4.59-2.71 11.18 11.18 0 01-2.7-4.59 15.75 15.75 0 01-.67-4.29 1 1 0 011-1h.84a1 1 0 01.71.29l.27.27a2.58 2.58 0 01.72 1.8c0 .4-.096.795-.28 1.15l-.63 1.27a1 1 0 000 .83 9.19 9.19 0 005 5 1 1 0 00.83 0l1.27-.64a2.57 2.57 0 013 .49l.27.28a1 1 0 01.29.7v.83a1 1 0 01-1.06 1h.01zM12.44 7.4a1 1 0 01.85-1.13 3.21 3.21 0 01.5 0c.43.006.858.073 1.27.2a3.87 3.87 0 012.51 2.51c.129.41.193.84.19 1.27a2.61 2.61 0 010 .5 1.01 1.01 0 01-2-.27v-.23a2 2 0 00-.1-.67 1.8 1.8 0 00-1.2-1.2 2.37 2.37 0 00-.67-.11 1.25 1.25 0 00-.22 0 1 1 0 01-1.13-.87zm9.17 1.88v.14a1 1 0 11-2 0v-.1a5.16 5.16 0 00-.21-1.42 4.77 4.77 0 00-3.26-3.3 5.16 5.16 0 00-1.42-.21h-.09a1 1 0 01-.05-2h.14a7 7 0 012 .3 6.76 6.76 0 014.6 4.6c.193.646.291 1.316.29 1.99z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "picture",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M19 2H5a3 3 0 00-3 3v14a3 3 0 003 3h14a3 3 0 003-3V5a3 3 0 00-3-3zM5 4h14a1 1 0 011 1v12.59l-1.88-1.88A3 3 0 0014 15.6l-2.89-2.89a3 3 0 00-4.24 0L4 15.59V5a1 1 0 011-1zm0 16a1 1 0 01-1-1v-.59l4.29-4.29a1 1 0 011.42 0l3.58 3.59a1 1 0 00.65.28h.13a1.06 1.06 0 00.64-.28l.58-.59a1.002 1.002 0 011.42 0l2.75 2.75A.91.91 0 0119 20H5zm10.33-8.43a2.9 2.9 0 100-5.8 2.9 2.9 0 000 5.8zm0-4a1.1 1.1 0 110 2.2 1.1 1.1 0 010-2.2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "pie_chart",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.08a.94.94 0 00-.558-.992A1 1 0 0021 12h-9V3c.01-.09.01-.18 0-.27A1 1 0 0010.92 2 10 10 0 1022 13.18v-.1zM12 20a8 8 0 01-2-15.77V13a1 1 0 00.29.71A1 1 0 0011 14h8.73A8 8 0 0112 20zm3-10h5.24a1 1 0 00.76-.4 1.001 1.001 0 00.2-.85 8 8 0 00-6-6 1 1 0 00-1.22.98V9A.999.999 0 0015 10zm3.83-2H16V5.15A6 6 0 0118.85 8h-.02z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "pin",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M20.66 7.76a3 3 0 00-.88-2.12l-1.42-1.42a3 3 0 00-4.24 0l-4.95 5-.71-.71a1 1 0 10-1.41 1.42l1.41 1.41 1.42 1.42-4.59 4.53a1.004 1.004 0 001.42 1.42l4.58-4.59 1.42 1.42L14.12 17a1.002 1.002 0 001.71-.705 1 1 0 00-.29-.705l-.71-.71 5-4.95a3 3 0 00.83-2.17zm-2.3.7l-4.95 4.95-2.82-2.82 4.95-4.95a1 1 0 01.7-.3 1 1 0 01.71.3l1.41 1.41a1 1 0 01.3.71 1 1 0 01-.3.7z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "plane",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M23 12a3.31 3.31 0 00-1-2.24 6.61 6.61 0 00-2-1.41s-.05 0-.09-.06L6.26 2.54A3.22 3.22 0 005 2.27a3.28 3.28 0 00-3.33 3.28 4.15 4.15 0 00.41 1.68L3.93 12l-1.85 4.78a4.24 4.24 0 00-.41 1.68A3.29 3.29 0 005 21.75c.44-.002.876-.093 1.28-.27l13.61-5.75a.6.6 0 00.13-.09 6.62 6.62 0 002-1.51 4 4 0 00.68-1A2.71 2.71 0 0023 12zM5 4.27c.22 0 .436.056.63.16a.58.58 0 00.14.05L18.6 9.92c.66.25 1.27.615 1.8 1.08H5.69L3.77 6.06a1.55 1.55 0 01-.09-.5A1.28 1.28 0 015 4.27zM3.67 18.46a1.5 1.5 0 01.09-.46l1.93-5h14.63a5.429 5.429 0 01-1.72 1.07L5.72 19.53h-.14a1.24 1.24 0 01-.63.17 1.29 1.29 0 01-1.28-1.24z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "play",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M21.219 11.96L4 21.918V2l17.219 9.96z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "play_video_rectangle",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M19 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-3-3zm1 13a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h14a1 1 0 011 1v10zm-4.38-6.73L11.69 8a2 2 0 00-3 1.73v4.54a2 2 0 001.757 1.985A2 2 0 0011.69 16l3.93-2.27a2 2 0 000-3.46zm-1 1.73l-3.93 2.27V9.73L14.62 12z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "plus",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M13.004 19.071a1.004 1.004 0 01-2.008 0l.007-6.074-6.074.007a1.004 1.004 0 010-2.008l6.074.007-.007-6.074a1.004 1.004 0 012.008 0l-.007 6.074 6.074-.007a1.004 1.004 0 010 2.008l-6.074-.007.007 6.074z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "plus_round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16.001A8 8 0 0112 20zm4-8a1 1 0 01-1 1h-2v2a1 1 0 01-2 0v-2H9a1 1 0 010-2h2V9a1 1 0 012 0v2h2a1 1 0 011 1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "poker_face",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16.001A8 8 0 0112 20zm-3-8.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm7.5-1.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-.5 5a1 1 0 01-1 1H9a1 1 0 010-2h6a1 1 0 011 1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "recover",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12a9 9 0 01-17 4.2 1 1 0 111.77-.93 7.07 7.07 0 001.68 2.08A7 7 0 107.11 7H9a1 1 0 010 2H5a1 1 0 01-1-1V4a1 1 0 012 0v1.3A9 9 0 0121 12zm-9-3a1 1 0 00-1 1v2a1 1 0 00.29.7l2 2a1.004 1.004 0 101.42-1.42L13 11.59V10a1 1 0 00-1-1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "repeat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12 13.89c-.08.01-.16.01-.24 0h-.13l-.15-.08-.11-.06-2.44-2A.925.925 0 113.2 10.3l.77.63a8.1 8.1 0 0114.36-4 .999.999 0 11-1.56 1.25A6.1 6.1 0 006 11.12l1-.81a.9.9 0 011.1 1.39l-2.44 2a1.398 1.398 0 01-.17.09 1.57 1.57 0 01-.3.09l-.07.01zM22 12.3l-2.44-2a1.511 1.511 0 00-.18-.09l-.3-.09H19a.964.964 0 00-.24 0h-.14l-.14.08-.11.06-2.44 2a.902.902 0 001.15 1.39l1-.81a6.11 6.11 0 01-10.85 2.98 1 1 0 10-1.56 1.25 8.1 8.1 0 0014.36-4l.78.64A.922.922 0 1022 12.3z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "resizing",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fea)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.723 14.673l3.98 3.757 7.92-7.485-3.98-3.757-7.92 7.485zM20.67 6.565l-2.386-2.254a1.156 1.156 0 00-.79-.311h-.011a1.153 1.153 0 00-.79.311l-1.592 1.503L19.08 9.57l1.59-1.503a1.03 1.03 0 00.33-.745V7.31a1.03 1.03 0 00-.33-.745zM3 21l5.17-1.127-3.979-3.756L3 21z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fea"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(3 4)",
    d: "M0 0h18v17H0z"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "restore_down",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3h-8a3 3 0 00-3 3v1H6a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3v-1h1a3 3 0 003-3V6a3 3 0 00-3-3zm-3 15a1 1 0 01-1 1H6a1 1 0 01-1-1v-8a1 1 0 011-1h8a1 1 0 011 1v8zm4-4a1 1 0 01-1 1h-1v-5a3 3 0 00-3-3H9V6a1 1 0 011-1h8a1 1 0 011 1v8z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "sad",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16.001A8 8 0 0112 20zM7.5 10a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm9 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-.5 5.36a.902.902 0 01-.565 1.388.888.888 0 01-.925-.388 3 3 0 00-5 0 .89.89 0 01-1.25.25.9.9 0 01-.26-1.25 4.78 4.78 0 017.94 0H16z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "save",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M20.71 8.29l-5-5A1.05 1.05 0 0015 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V9a1.05 1.05 0 00-.29-.71zM9 19v-2a1 1 0 011-1h4a1 1 0 011 1v2H9zm9 0h-1v-2a3 3 0 00-3-3h-4a3 3 0 00-3 3v2H6a1 1 0 01-1-1V6a1 1 0 011-1h8.59L19 9.41V18a1 1 0 01-1 1zM13 8a1 1 0 01-1 1H8a1 1 0 010-2h4a1 1 0 011 1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "settings_vertical",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13.18V4a1 1 0 00-2 0v9.18a3 3 0 000 5.64V20a1 1 0 102 0v-1.18a3 3 0 000-5.64zM5 17a1 1 0 110-2 1 1 0 010 2zm8-11.82V4a1 1 0 00-2 0v1.18a3 3 0 000 5.64V20a1 1 0 002 0v-9.18a3 3 0 000-5.64zM12 9a1 1 0 110-2 1 1 0 010 2zm10 4a3 3 0 00-2-2.83 1.005 1.005 0 000-.17V4a1 1 0 00-2 0v6a1.005 1.005 0 000 .17 3 3 0 000 5.65V20a1 1 0 002 0v-4.18A3 3 0 0022 13zm-3 1a1 1 0 110-2 1 1 0 010 2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "shield_copy",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M15.77 19.79a11 11 0 005.11-9.29V7.38a3 3 0 00-1.94-2.8l-5.87-2.24a3 3 0 00-2.14 0h-.1L5.06 4.58a3 3 0 00-1.93 2.8v3.12a11 11 0 005.1 9.29l2.16 1.37a3 3 0 003.22 0l2.16-1.37zm3.11-9.29a9 9 0 01-4.18 7.6l-2.16 1.38a1 1 0 01-1.08 0L9.3 18.1a9 9 0 01-4.17-7.6V7.38a1 1 0 01.64-.94l5.87-2.23a1 1 0 01.72 0l5.87 2.23a1 1 0 01.65.94v3.12z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "shopping_bag_handles_down",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H6a1 1 0 01-1-1V6a1 1 0 011-1h12a1 1 0 011 1v12zM17 8A5 5 0 117 8a1 1 0 012 0 3 3 0 106 0 1 1 0 012 0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "smartphone",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17a1 1 0 01-1 1h-4a1 1 0 010-2h4a1 1 0 011 1zm4-12v14a3 3 0 01-3 3H8a3 3 0 01-3-3V5a3 3 0 013-3h8a3 3 0 013 3zm-2 0a1 1 0 00-1-1H8a1 1 0 00-1 1v14a1 1 0 001 1h8a1 1 0 001-1V5z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "smile",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16.001A8 8 0 0112 20zM7.5 10a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm9 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-.77 3.39a.9.9 0 01.27 1.25 4.78 4.78 0 01-7.94 0 .9.9 0 011.243-1.252.89.89 0 01.247.252 3 3 0 005 0 .89.89 0 011.18-.25z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "sort",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M21 6a1 1 0 01-1 1H4a1 1 0 010-2h16a1 1 0 011 1zm-6 5H4a1 1 0 000 2h11a1 1 0 000-2zm-5 6H4a1 1 0 000 2h6a1 1 0 000-2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "sort_arrow_down",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M23 7a1 1 0 01-1 1H12a1 1 0 110-2h10a1 1 0 011 1zm-4 4h-7a1 1 0 000 2h7a1 1 0 000-2zm-4 5h-3a1 1 0 000 2h3a1 1 0 000-2zm-6.58-1.21L7 16V6a1 1 0 10-2 0v10l-1.42-1.21a.85.85 0 10-1.11 1.28l3 2.58a.533.533 0 00.1.06.71.71 0 00.15.08h.62a.71.71 0 00.15-.08.533.533 0 00.1-.06l3-2.58a.85.85 0 10-1.11-1.28h-.06z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "sort_arrow_up",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M23 7a1 1 0 01-1 1H12a1 1 0 110-2h10a1 1 0 011 1zm-4 4h-7a1 1 0 000 2h7a1 1 0 000-2zm-4 5h-3a1 1 0 000 2h3a1 1 0 000-2zM6.56 5.21a.53.53 0 00-.1-.06.71.71 0 00-.15-.08L6.16 5h-.47a.71.71 0 00-.15.08.53.53 0 00-.1.06l-3 2.58a.883.883 0 101.14 1.35L5 7.84v10a1 1 0 102 0v-10l1.42 1.23a.85.85 0 101.11-1.28L6.56 5.21z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "sound_high",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.74a1.071 1.071 0 00-.07-.19v-.06c0-.06-.06-.06-.08-.09a.67.67 0 00-.14-.15l-.15-.11a.999.999 0 00-.18-.08h-.2L12 5h-.26l-.19.07h-.06L6.72 8H5a3 3 0 00-3 3v2a3 3 0 003 3h1.72l4.77 2.86h.06l.19.07h.57a.906.906 0 00.18-.08l.15-.11a.67.67 0 00.14-.15s.06-.05.08-.09c.02-.04 0 0 0-.06.03-.061.053-.125.07-.19a1.282 1.282 0 000-.19L13 18V5.93a1.282 1.282 0 000-.19zM4 13v-2a1 1 0 011-1h2.26l.19-.07h.06L11 7.77v8.46l-3.49-2.09h-.06l-.19-.07H5A1.002 1.002 0 014 13zm18-1a10.77 10.77 0 01-2.21 6.61 1.001 1.001 0 01-1.58-1.23A8.72 8.72 0 0020 12a8.69 8.69 0 00-1.79-5.37 1 1 0 01.917-1.61 1 1 0 01.663.38A10.74 10.74 0 0122 12zm-5.15-3.74a6.7 6.7 0 010 7.48 1 1 0 11-1.67-1.08A5 5 0 0016 12a5 5 0 00-.81-2.66 1 1 0 111.67-1.08h-.01z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "sound_low",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.74a1.071 1.071 0 00-.07-.19v-.06c0-.06-.06-.06-.08-.09a.67.67 0 00-.14-.15l-.15-.11a.999.999 0 00-.18-.08h-.2L14 5h-.26l-.19.07h-.06L8.72 8H7a3 3 0 00-3 3v2a3 3 0 003 3h1.72l4.77 2.86h.06l.19.07h.57a.906.906 0 00.18-.08l.15-.11a.67.67 0 00.14-.15s.06-.05.08-.09c.02-.04 0 0 0-.06.03-.061.053-.125.07-.19a1.282 1.282 0 000-.19L15 18V5.93a1.282 1.282 0 000-.19zM6 13v-2a1 1 0 011-1h2.26l.19-.07h.06L13 7.77v8.46l-3.49-2.09h-.06l-.19-.07H7A1.002 1.002 0 016 13zm12.85-4.74a1 1 0 10-1.67 1.08A5 5 0 0118 12a5 5 0 01-.81 2.66 1 1 0 101.67 1.08 6.7 6.7 0 000-7.48h-.01z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "speech_bubble",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3H6a3 3 0 00-3 3v10a3 3 0 003 3h2v2a1 1 0 001.51.88L14.27 19H18a3 3 0 003-3V6a3 3 0 00-3-3zm1 13a1 1 0 01-1 1h-4a1 1 0 00-.51.14L10 19.22V18a1 1 0 00-.29-.72A1 1 0 009 17H6a1 1 0 01-1-1V6a1 1 0 011-1h12a1 1 0 011 1v10zm-3-7a1 1 0 01-1 1H9a1 1 0 010-2h6a1 1 0 011 1zm-3 4a1 1 0 01-1 1H9a1 1 0 010-2h3a1 1 0 011 1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "split_screen_horizontal",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11h12a3 3 0 003-3V6a3 3 0 00-3-3H6a3 3 0 00-3 3v2a3 3 0 003 3zM5 8V6a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H6a1 1 0 01-1-1zm13 5H6a3 3 0 00-3 3v2a3 3 0 003 3h12a3 3 0 003-3v-2a3 3 0 00-3-3zm1 5a1 1 0 01-1 1H6a1 1 0 01-1-1v-2a1 1 0 011-1h12a1 1 0 011 1v2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "split_screen_vertical",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3H6a3 3 0 00-3 3v12a3 3 0 003 3h2a3 3 0 003-3V6a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H6a1 1 0 01-1-1V6a1 1 0 011-1h2a1 1 0 011 1v12zm9-15h-2a3 3 0 00-3 3v12a3 3 0 003 3h2a3 3 0 003-3V6a3 3 0 00-3-3zm1 15a1 1 0 01-1 1h-2a1 1 0 01-1-1V6a1 1 0 011-1h2a1 1 0 011 1v12z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "spoon_and_fork",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1.5A4.32 4.32 0 003.27 3 5.3 5.3 0 002 6.5v1a4.93 4.93 0 002 4V20a2.5 2.5 0 005 0v-8.46a4.93 4.93 0 002-4v-1A5.3 5.3 0 009.73 3 4.32 4.32 0 006.5 1.5zm2.5 6A2.91 2.91 0 017.8 10a2 2 0 00-.8 1.56V20a.5.5 0 01-1 0v-8.44A2 2 0 005.2 10 2.91 2.91 0 014 7.5v-1a3.28 3.28 0 01.78-2.17 2.2 2.2 0 013.44 0A3.28 3.28 0 019 6.5v1zM22 3a1 1 0 00-2 0v4.5a2.91 2.91 0 01-1.2 2.5 2 2 0 00-.8 1.61V20a.5.5 0 01-1 0v-8.44a1.998 1.998 0 00-.8-1.56A2.941 2.941 0 0115 7.5V3a1 1 0 00-2 0v5c0 .134.027.267.08.39A4.83 4.83 0 0015 11.54V20a2.5 2.5 0 005 0v-8.46a4.83 4.83 0 001.92-3.15c.052-.123.08-.256.08-.39V3zm-5.5 4V3a1 1 0 012 0v4a1 1 0 01-2 0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "star",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3 3.313a2.09 2.09 0 00-3.88 0l-1.76 4.3-.08.06-4.63.34a2.08 2.08 0 00-1.43.71 2.12 2.12 0 00-.52 1.38 2.08 2.08 0 00.75 1.6l3.55 3v.07l-1.08 4.55c-.04.17-.06.345-.06.52a2 2 0 00.63 1.49 2.08 2.08 0 002.57.27l4-2.45h.1l3.9 2.45a2.08 2.08 0 002.57-.28 2 2 0 00.63-1.49c0-.172-.02-.343-.06-.51l-1.14-4.54v-.07l3.55-3a2.098 2.098 0 00.23-3 2.08 2.08 0 00-1.43-.71l-4.63-.34-.08-.06-1.76-4.3.06.01zm2.77 9.86a2.11 2.11 0 00-.68 2.1l1.1 4.48v.05h-.13l-3.94-2.45a2.14 2.14 0 00-2.22 0l-3.84 2.55h-.08v-.05l1.11-4.52a2.11 2.11 0 00-.68-2.1l-3.55-3v-.14h.06l4.64-.34a2.09 2.09 0 001.78-1.3l1.63-4.35v-.05h.12v.05l1.76 4.3a2.09 2.09 0 001.78 1.3l4.64.34h.06v.14l-3.56 2.99z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "table",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M19 2H5a3 3 0 00-3 3v14a3 3 0 003 3h14a3 3 0 003-3V5a3 3 0 00-3-3zM4 10h4v4H4v-4zm6 0h10v4H10v-4zm9-6a1 1 0 011 1v3H10V4h9zM5 4h3v4H4V5a1 1 0 011-1zM4 19v-3h4v4H5a1 1 0 01-1-1zm16 0a1 1 0 01-1 1h-9v-4h10v3z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "target",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.07A9.93 9.93 0 1021.93 12 9.92 9.92 0 0012 2.07zm5.61 15.54A7.94 7.94 0 1119.93 12a7.9 7.9 0 01-2.32 5.61zM12 6.24a5.76 5.76 0 100 11.52 5.76 5.76 0 000-11.52zm2.66 8.42a3.77 3.77 0 11-5.34-5.323 3.77 3.77 0 015.34 5.323zM13.5 12a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "teams",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.2 15.61a3.15 3.15 0 00-1.853.602l-.168.122c-.9.655-.437 2.08.676 2.08h7.52c1.113 0 1.577-1.425.676-2.08l-.168-.122a3.15 3.15 0 00-1.852-.602H6.2zm-2.853-.772A4.85 4.85 0 016.2 13.91h4.83a4.85 4.85 0 012.853.928l.168.122c2.232 1.623 1.084 5.154-1.676 5.154h-7.52c-2.76 0-3.908-3.531-1.676-5.155l.168-.121zM8.615 5.7a2.754 2.754 0 100 5.507 2.754 2.754 0 000-5.507zM4.161 8.454a4.454 4.454 0 118.908 0 4.454 4.454 0 01-8.908 0zm11.863 3.19a1.97 1.97 0 00-1.158.376c-.537.39-.26 1.239.403 1.239h4.485c.663 0 .94-.848.403-1.239a1.97 1.97 0 00-1.159-.376h-2.974zm-1.864-.594a3.17 3.17 0 011.864-.606h2.974c.67 0 1.323.212 1.865.606 1.476 1.074.716 3.409-1.109 3.409H15.27c-1.826 0-2.585-2.335-1.109-3.41zm3.351-5.6a1.652 1.652 0 100 3.305 1.652 1.652 0 000-3.305zM14.66 7.102a2.852 2.852 0 115.705 0 2.852 2.852 0 01-5.705 0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "thumbs_down",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2 3a3 3 0 00-1.92.71A3 3 0 0014.37 3h-6.1a3.61 3.61 0 00-1.87.5 5.22 5.22 0 00-1.9 2.12 18.7 18.7 0 00-1.25 3.06 8.49 8.49 0 00-.45 2.7 6.05 6.05 0 00.76 3.09 3.47 3.47 0 001 1.08A2.68 2.68 0 006 16h2.2a.36.36 0 01.29.12.4.4 0 01.12.29v.11l-.8 1.83a3 3 0 00.63 3.32l.22.21a2 2 0 003-.21L16 16a3 3 0 005.24-2V6a3.002 3.002 0 00-3.04-3zm-8.11 17.48l-.22-.22a1 1 0 01-.29-.71 1.14 1.14 0 01.08-.4l.84-1.89v-.09a2.51 2.51 0 00.12-.76 2.45 2.45 0 00-.62-1.69A2.42 2.42 0 008.24 14H6a.59.59 0 01-.36-.11 1.74 1.74 0 01-.59-.84 4.5 4.5 0 01-.29-1.67 6.5 6.5 0 01.35-2.06A12.88 12.88 0 016.64 6a2.64 2.64 0 01.77-.74A1.64 1.64 0 018.27 5h6.1c.265.004.518.107.71.29l.17.18a3.07 3.07 0 00-.05.53v7.67l-5.11 6.81zM19.2 14a1 1 0 01-2 0V6a1 1 0 012 0v8z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "thumbs_up",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16.32a8.78 8.78 0 00.45-2.7 6.15 6.15 0 00-.76-3.09 3.47 3.47 0 00-1-1.08A2.68 2.68 0 0018.16 9H16a.38.38 0 01-.29-.12.45.45 0 01-.12-.29v-.11l.81-1.83a3.001 3.001 0 00-.63-3.32l-.22-.22a2 2 0 00-3 .21L8.24 9A3 3 0 003 11v8a3 3 0 003 3 2.94 2.94 0 001.91-.71 3 3 0 001.92.71h6.09a3.65 3.65 0 001.88-.5 5.22 5.22 0 001.9-2.12c.52-.981.954-2.005 1.3-3.06zM6 20a1 1 0 01-1-1v-8a1 1 0 112 0v8a1 1 0 01-1 1zm11.56-1a2.77 2.77 0 01-.77.74 1.67 1.67 0 01-.87.22H9.83a1 1 0 01-.71-.29L9 19.53A3.07 3.07 0 009 19v-7.67l5.11-6.81.22.22a1 1 0 01.29.71 1 1 0 01-.09.4l-.83 1.89v.09c-.087.244-.13.501-.13.76A2.411 2.411 0 0016 11h2.21a.63.63 0 01.36.11c.277.214.482.507.59.84.202.533.3 1.1.29 1.67a6.5 6.5 0 01-.35 2.06A12.882 12.882 0 0117.56 19z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "tools",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M21.71 16.29l-4.8-4.79 3.38-3.38a3 3 0 000-4.24l-.17-.17a3 3 0 00-4.24 0L12.5 7.09l-4.79-4.8a1 1 0 00-1.42 0l-4 4a1 1 0 000 1.42l4.8 4.79-2.8 2.79a1 1 0 00-.26.47l-1 4A1 1 0 004.24 21l4-1a1 1 0 00.47-.26l2.79-2.8 4.79 4.8a1.002 1.002 0 001.42 0l4-4a1.002 1.002 0 000-1.42v-.03zM17.29 5.12a1 1 0 011.42 0l.17.17a1 1 0 010 1.42l-.88.88L16.41 6l.88-.88zM15 7.41L16.59 9l-1.09 1.09-1.59-1.59L15 7.41zM7.49 18.1l-2.12.53.53-2.12 2.6-2.6 1.59 1.59-2.6 2.6zM17 19.59L4.41 7 7 4.41 8.09 5.5l-.8.79a1.004 1.004 0 101.42 1.42l.79-.8 1.59 1.59-.8.79a1.004 1.004 0 001.42 1.42l.79-.8 1.59 1.59-.8.79a1.004 1.004 0 101.42 1.42l.79-.8 1.59 1.59-.8.79a1.004 1.004 0 101.42 1.42l.79-.8L19.59 17 17 19.59z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "truck",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M21.47 10.7l-1-2A3 3 0 0017.76 7H15a3 3 0 00-3-3H5a3 3 0 00-3 3v8a3 3 0 002.14 2.86 3 3 0 005.68.14h4.36a3 3 0 005.64 0H20a2 2 0 002-2v-3a5 5 0 00-.53-2.3zM4 7a1 1 0 011-1h7a1 1 0 011 1v9H9.82a3 3 0 00-5.52-.29A1 1 0 014 15V7zm3 11a1 1 0 110-2 1 1 0 010 2zm10 0a1 1 0 110-2 1 1 0 010 2zm3-2h-.18A3 3 0 0017 14a3 3 0 00-2 .78V9h2.76a1 1 0 01.9.55l.23.46H17a1 1 0 000 2h2.83c.111.318.168.653.17.99v3zM9 11V9a1 1 0 012 0v2a1 1 0 01-2 0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "uneven_line_copy",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.2a1 1 0 01-1 1h-2.13a.69.69 0 00-.1.25l-.66 3.36a2.54 2.54 0 01-.64 1.3 1.779 1.779 0 01-2.65-.11 2.67 2.67 0 01-.62-1.41l-1.35-9.78-1.18 6.27a2.46 2.46 0 01-.64 1.3 1.81 1.81 0 01-1.31.62 1.84 1.84 0 01-1.16-.44 2.39 2.39 0 01-.68-1l-1-3L6.21 13a2.28 2.28 0 01-.66.85 1.76 1.76 0 01-1.09.38H3a1 1 0 010-2h1.35v-.06l.75-1.63a2.22 2.22 0 01.68-.87A1.78 1.78 0 018 9.73c.31.268.545.613.68 1l1 2.9 1.22-6.29A2.64 2.64 0 0111.54 6a1.78 1.78 0 012.66.05 2.6 2.6 0 01.62 1.41l1.35 9.82.64-3.24c.083-.46.29-.889.6-1.24a1.85 1.85 0 011.34-.62H21a1.001 1.001 0 011 1.02z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "upload",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38 8a.85.85 0 01.09-1.2l3-2.58a.53.53 0 01.1-.06.71.71 0 01.15-.08h.15L12 4h.31a.71.71 0 01.15.08.53.53 0 01.1.06l3 2.58A.85.85 0 1114.45 8L13 6.84v8a1 1 0 01-2 0v-8L9.58 8.07A.85.85 0 018.38 8zM20 14a1 1 0 00-1 1v3a1 1 0 01-1 1H6a1 1 0 01-1-1v-3a1 1 0 10-2 0v3a3 3 0 003 3h12a3 3 0 003-3v-3a1 1 0 00-1-1z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "usd_circle",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.85a2.91 2.91 0 00-2-.85h-1.94a.93.93 0 01-.804-.535.811.811 0 01-.066-.315v-.09a1.2 1.2 0 01.42-.76c.4-.298.891-.45 1.39-.43.143-.01.287-.01.43 0a2.75 2.75 0 011.5.7 1.002 1.002 0 101.33-1.5A4.86 4.86 0 0013 7V6a1 1 0 00-2 0v1a3.82 3.82 0 00-1.68.79 3.22 3.22 0 00-1.11 2.08 2.534 2.534 0 000 .28 2.84 2.84 0 00.84 2A2.91 2.91 0 0011 13h1.94a1 1 0 01.62.26.85.85 0 01.25.59v.08c-.04.3-.19.574-.42.77-.4.298-.891.45-1.39.43-.143.01-.287.01-.43 0a2.9 2.9 0 01-1.5-.7 1 1 0 10-1.33 1.49A4.78 4.78 0 0011 17v1a1 1 0 002 0v-1a3.84 3.84 0 001.68-.8 3.17 3.17 0 001.11-2.08 2.615 2.615 0 000-.28 2.84 2.84 0 00-.79-1.99zm7 .15a10 10 0 11-20 0 10 10 0 0120 0zm-2 0a8 8 0 10-16 .013A8 8 0 0020 12z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "user",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13a5 5 0 100-10 5 5 0 000 10zm0-8a3 3 0 110 6 3 3 0 010-6zm7 13v2a1 1 0 01-2 0v-2a1 1 0 00-1-1H8a1 1 0 00-1 1v2a1 1 0 11-2 0v-2a3 3 0 013-3h8a3 3 0 013 3z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "user-1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.743 4.308c-1.75 0-3.17 1.38-3.17 3.083 0 1.703 1.42 3.083 3.17 3.083 1.752 0 3.171-1.38 3.171-3.083 0-1.703-1.42-3.083-3.17-3.083zM7.227 7.391C7.227 4.966 9.25 3 11.743 3c2.495 0 4.516 1.966 4.516 4.391s-2.021 4.391-4.516 4.391c-2.494 0-4.516-1.966-4.516-4.391zm-2.38 8.615c1.397-1.45 3.668-2.542 7.153-2.542 3.485 0 5.756 1.092 7.153 2.542C20.532 17.44 21 19.162 21 20.346a.663.663 0 01-.673.654H3.673A.663.663 0 013 20.346c0-1.184.468-2.907 1.847-4.34zm-.445 3.686h15.196A5.34 5.34 0 0018.17 16.9c-1.102-1.144-2.994-2.128-6.171-2.128s-5.07.984-6.17 2.128a5.34 5.34 0 00-1.428 2.792z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "user_round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6a4 4 0 100 8 4 4 0 000-8zm0 6a2 2 0 110-4 2 2 0 010 4zm0-10a10 10 0 100 20 10 10 0 000-20zM8 18.92V18a1 1 0 011-1h6a1 1 0 011 1v.92a7.95 7.95 0 01-8 0zm9.93-1.57A3 3 0 0015 15H9a3 3 0 00-2.93 2.35 8 8 0 1111.86 0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "users",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13a4 4 0 100-8 4 4 0 000 8zm0-6a2 2 0 110 4 2 2 0 010-4zm5 10v2a1 1 0 01-2 0v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 11-2 0v-2a3 3 0 013-3h4a3 3 0 013 3zm5-6a4 4 0 100-8 4 4 0 000 8zm0-6a2 2 0 110 4 2 2 0 010-4zm5 10v2a1 1 0 01-2 0v-2a1 1 0 00-1-1h-4a1 1 0 00-.49.13 1 1 0 00-.4.41 1 1 0 11-1.77-.93 3.06 3.06 0 011.19-1.23A3 3 0 0115 12h4a3 3 0 013 3z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "video_camera",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16V8a1.282 1.282 0 000-.19c.005-.06.005-.12 0-.18a1 1 0 00-.16-.25.56.56 0 01-.05-.08l-.16-.1a.912.912 0 00-.16-.11h-.09A.94.94 0 0020 7a1 1 0 00-.18 0 1.08 1.08 0 00-.19 0L16 8.52V8a3 3 0 00-3-3H5a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3v-.52l3.61 1.44h.18c.068.033.138.06.21.08a.942.942 0 00.29-.06h.09a.912.912 0 00.16-.11l.16-.1a.56.56 0 01.05-.08 1 1 0 00.16-.25c.005-.06.005-.12 0-.18A1.24 1.24 0 0021 16zm-8 1H5a1 1 0 01-1-1V8a1 1 0 011-1h8a1 1 0 011 1v8a1 1 0 01-1 1zm3-6.32l3-1.2v5l-3-1.2v-2.6z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "waiting",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13H3a1 1 0 010-2h4a1 1 0 010 2zm.73-3.86a1 1 0 101.41-1.42L6.31 4.9A1 1 0 004.9 6.31l2.83 2.83zM12 2a1 1 0 00-1 1v4a1 1 0 002 0V3a1 1 0 00-1-1zm9 9h-4a1 1 0 000 2h4a1 1 0 000-2zm-9 5a1 1 0 00-1 1v4a1 1 0 002 0v-4a1 1 0 00-1-1zm4.2-1.21a1.002 1.002 0 00-1.71.705 1 1 0 00.29.705l2.83 2.8A1 1 0 0019 19a1 1 0 000-1.41l-2.8-2.8zm-8.45 0l-2.83 2.84a1 1 0 101.41 1.42l2.83-2.83a1 1 0 10-1.41-1.42v-.01zm8.5-5.68l2.83-2.81a1 1 0 10-1.41-1.42l-2.83 2.83a1 1 0 001.41 1.41v-.01z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "warning",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8v5a1 1 0 01-2 0V8a1 1 0 012 0zm-1.71 7.29zM11 16zm1-1a1 1 0 100 2 1 1 0 000-2zm10-3a10 10 0 11-20 0 10 10 0 0120 0zm-2 0a8 8 0 10-16 0 8 8 0 0016 0z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "watch",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16.001A8 8 0 0112 20zm2.71-6.71a1.004 1.004 0 11-1.42 1.42l-2-2A1 1 0 0111 12V9a1 1 0 012 0v2.59l1.71 1.7z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "website",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M19 2H5a3 3 0 00-3 3v14a3 3 0 003 3h14a3 3 0 003-3V5a3 3 0 00-3-3zM5 4h14a1 1 0 011 1v3H4V5a1 1 0 011-1zm0 16a1 1 0 01-1-1v-9h4v10H5zm15-1a1 1 0 01-1 1h-9V10h10v9z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "wrench",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M20.16 17.66a2.5 2.5 0 01-4.27 1.76l-5.7-5.69A5.539 5.539 0 018.5 14a4.844 4.844 0 01-.92-.08A5.47 5.47 0 013 8.5 5.39 5.39 0 013.59 6a1 1 0 011.6-.26l2.52 2.55a.41.41 0 10.58-.58L5.77 5.19a1 1 0 01-.28-.87A1 1 0 016 3.59c.206-.11.42-.203.64-.28A5.54 5.54 0 018.5 3c.335.001.67.028 1 .08a5.53 5.53 0 014.45 4.54c.042.291.058.586.05.88a5.54 5.54 0 01-.27 1.69l5.69 5.7a2.48 2.48 0 01.74 1.77zm-2 0a.508.508 0 00-.16-.36l-6-6v-.06l-.21-.24a1 1 0 01-.12-1c.22-.47.333-.982.33-1.5.02-.19.02-.38 0-.57a3.49 3.49 0 00-2.87-2.87A3.361 3.361 0 008.5 5h-.08l1.29 1.3a2.39 2.39 0 010 3.4 2.44 2.44 0 01-3.42 0L5 8.42v.08a3.25 3.25 0 00.08.75A3.5 3.5 0 007.9 12c.199.03.4.047.6.05a3.49 3.49 0 001.5-.38 1 1 0 011 .12l.22.17.09.08 6 6a.51.51 0 00.36.15.51.51 0 00.5-.5l-.01-.03z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "writing",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24 18l4-1a1 1 0 00.47-.26l9.58-9.59a3 3 0 000-4.24l-.17-.17a3 3 0 00-4.24 0l-9.59 9.55a1 1 0 00-.26.47l-1 4A1 1 0 005.24 18zM17 3.83a1 1 0 01.71.29l.17.17a1 1 0 010 1.42l-1.4 1.39-1.58-1.58 1.39-1.4a1 1 0 01.71-.29zM6.9 13.51l6.58-6.58 1.59 1.59-6.58 6.58-2.12.53.53-2.12zM22 20a1 1 0 01-1 1H5a1 1 0 010-2h16a1 1 0 011 1zm-8-5h7a1 1 0 010 2h-7a1 1 0 010-2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "x_round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16.001A8 8 0 0112 20zm3-9.54L13.41 12 15 13.54A1.032 1.032 0 1113.54 15L12 13.41 10.46 15A1.032 1.032 0 119 13.54L10.59 12 9 10.46A1.032 1.032 0 1110.46 9L12 10.59 13.54 9A1.032 1.032 0 1115 10.46z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.a817982dc580942bf7e7408837110085.svg";
export { ForwardRef as ReactComponent };